var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1527 807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M1527 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M1514.23 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M1514.23 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M1501.46 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M1501.46 176.76a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M1501.46 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M1488.68 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M1488.68 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M1488.68 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M1488.68 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M1488.68 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M1488.68 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M1475.91 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M1475.91 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M1475.91 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-1",
    d: "M1475.91 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M1475.91 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M1475.91 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M1475.91 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M1475.91 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M1463.15 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M1463.15 176.76a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M1463.15 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M1463.15 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M1463.15 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M1463.15 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M1463.15 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M1463.15 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M1463.15 712.93a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M1463.15 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M1450.37 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M1450.37 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M1450.37 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M1450.37 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M1450.37 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M1450.37 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M1450.37 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M1450.37 738.47a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M1437.6 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M1437.6 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M1437.6 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "M1437.6 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-1",
    d: "M1437.6 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-1",
    d: "M1437.6 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-1",
    d: "M1437.6 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-1",
    d: "M1437.6 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-1",
    d: "M1437.6 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-1",
    d: "M1437.6 738.47a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-1",
    d: "M1424.83 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-1",
    d: "M1424.83 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-1",
    d: "M1424.83 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-1",
    d: "M1424.83 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-1",
    d: "M1424.83 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-1",
    d: "M1424.83 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-1",
    d: "M1424.83 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-1",
    d: "M1424.83 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-1",
    d: "M1412.06 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-1",
    d: "M1412.06 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-1",
    d: "M1412.06 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-1",
    d: "M1412.06 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-1",
    d: "M1412.06 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-1",
    d: "M1412.06 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-1",
    d: "M1412.06 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-1",
    d: "M1412.06 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M1412.06 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M1399.29 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M1399.29 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M1399.29 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M1399.29 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M1399.29 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M1399.29 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-1",
    d: "M1399.29 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-1",
    d: "M1399.29 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-1",
    d: "M1399.29 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-1",
    d: "M1399.29 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-1",
    d: "M1386.51 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-1",
    d: "M1386.51 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-1",
    d: "M1386.51 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-1",
    d: "M1386.51 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-1",
    d: "M1386.51 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-1",
    d: "M1386.51 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-1",
    d: "M1386.51 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-1",
    d: "M1386.51 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-1",
    d: "M1373.74 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-1",
    d: "M1373.74 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-1",
    d: "M1373.74 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-1",
    d: "M1373.74 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-1",
    d: "M1373.74 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-1",
    d: "M1373.74 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-1",
    d: "M1373.74 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-1",
    d: "M1373.74 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-1",
    d: "M1373.74 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-1",
    d: "M1373.74 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-1",
    d: "M1373.74 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-1",
    d: "M1361 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-1",
    d: "M1361 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-1",
    d: "M1361 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-1",
    d: "M1361 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-1",
    d: "M1361 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-1",
    d: "M1361 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-1",
    d: "M1361 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-1",
    d: "M1361 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-1",
    d: "M1361 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-1",
    d: "M1361 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-1",
    d: "M1361 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-1",
    d: "M1361 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-1",
    d: "M1361 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-1",
    d: "M1361 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-1",
    d: "M1361 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-1",
    d: "M1361 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-1",
    d: "M1348.2 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-1",
    d: "M1348.2 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-1",
    d: "M1348.2 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-1",
    d: "M1348.2 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-1",
    d: "M1348.2 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-1",
    d: "M1348.2 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-1",
    d: "M1348.2 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-1",
    d: "M1348.2 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-1",
    d: "M1348.2 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-1",
    d: "M1348.2 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-1",
    d: "M1348.2 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-1",
    d: "M1348.2 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-1",
    d: "M1348.2 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-1",
    d: "M1348.2 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-1",
    d: "M1348.2 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-1",
    d: "M1348.2 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-1",
    d: "M1348.2 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-1",
    d: "M1348.2 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M1348.2 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M1348.2 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M1335.43 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M1335.43 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-1",
    d: "M1335.43 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M1335.43 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-1",
    d: "M1335.43 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-1",
    d: "M1335.43 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-1",
    d: "M1335.43 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-1",
    d: "M1335.43 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-1",
    d: "M1335.43 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-1",
    d: "M1335.43 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-1",
    d: "M1335.43 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-1",
    d: "M1335.43 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-1",
    d: "M1335.43 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-1",
    d: "M1335.43 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-1",
    d: "M1335.43 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-1",
    d: "M1335.43 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-1",
    d: "M1335.43 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-1",
    d: "M1335.43 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-1",
    d: "M1335.43 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-1",
    d: "M1335.43 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-1",
    d: "M1335.43 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-1",
    d: "M1335.43 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-1",
    d: "M1335.43 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-1",
    d: "M1335.43 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-1",
    d: "M1335.43 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-1",
    d: "M1335.43 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-1",
    d: "M1335.43 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-1",
    d: "M1322.66 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-1",
    d: "M1322.66 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-1",
    d: "M1322.66 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-1",
    d: "M1322.66 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-1",
    d: "M1322.66 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-1",
    d: "M1322.66 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-1",
    d: "M1322.66 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-1",
    d: "M1322.66 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-1",
    d: "M1322.66 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-1",
    d: "M1322.66 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-1",
    d: "M1322.66 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-1",
    d: "M1322.66 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "cls-1",
    d: "M1322.66 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "cls-1",
    d: "M1322.66 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "cls-1",
    d: "M1322.66 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    className: "cls-1",
    d: "M1322.66 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-1",
    d: "M1322.66 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-1",
    d: "M1322.66 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-1",
    d: "M1322.66 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-1",
    d: "M1322.66 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-1",
    d: "M1322.66 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-1",
    d: "M1322.66 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-1",
    d: "M1322.66 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-1",
    d: "M1322.66 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-1",
    d: "M1322.66 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-1",
    d: "M1322.66 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-1",
    d: "M1322.66 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-1",
    d: "M1322.66 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-1",
    d: "M1322.66 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-1",
    d: "M1322.66 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    className: "cls-1",
    d: "M1322.66 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    className: "cls-1",
    d: "M1309.89 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    className: "cls-1",
    d: "M1309.89 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    className: "cls-1",
    d: "M1309.89 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    className: "cls-1",
    d: "M1309.89 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    className: "cls-1",
    d: "M1309.89 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    className: "cls-1",
    d: "M1309.89 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    className: "cls-1",
    d: "M1309.89 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    className: "cls-1",
    d: "M1309.89 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    className: "cls-1",
    d: "M1309.89 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    className: "cls-1",
    d: "M1309.89 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    className: "cls-1",
    d: "M1309.89 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    className: "cls-1",
    d: "M1309.89 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    className: "cls-1",
    d: "M1309.89 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    className: "cls-1",
    d: "M1309.89 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    className: "cls-1",
    d: "M1309.89 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    className: "cls-1",
    d: "M1309.89 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    className: "cls-1",
    d: "M1309.89 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    className: "cls-1",
    d: "M1309.89 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    className: "cls-1",
    d: "M1309.89 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    className: "cls-1",
    d: "M1309.89 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    className: "cls-1",
    d: "M1309.89 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    className: "cls-1",
    d: "M1309.89 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    className: "cls-1",
    d: "M1309.89 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    className: "cls-1",
    d: "M1309.89 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    className: "cls-1",
    d: "M1309.89 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    className: "cls-1",
    d: "M1309.89 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    className: "cls-1",
    d: "M1309.89 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    className: "cls-1",
    d: "M1309.89 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    className: "cls-1",
    d: "M1297.11 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    className: "cls-1",
    d: "M1297.11 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    className: "cls-1",
    d: "M1297.11 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    className: "cls-1",
    d: "M1297.11 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    className: "cls-1",
    d: "M1297.11 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    className: "cls-1",
    d: "M1297.11 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    className: "cls-1",
    d: "M1297.11 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-1",
    d: "M1297.11 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-1",
    d: "M1297.11 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-1",
    d: "M1297.11 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-1",
    d: "M1297.11 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    className: "cls-1",
    d: "M1297.11 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    className: "cls-1",
    d: "M1297.11 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    className: "cls-1",
    d: "M1297.11 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    className: "cls-1",
    d: "M1297.11 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    className: "cls-1",
    d: "M1297.11 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-1",
    d: "M1297.11 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    className: "cls-1",
    d: "M1297.11 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    className: "cls-1",
    d: "M1297.11 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-1",
    d: "M1297.11 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-1",
    d: "M1297.11 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-1",
    d: "M1297.11 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-1",
    d: "M1297.11 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-1",
    d: "M1297.11 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-1",
    d: "M1297.11 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    className: "cls-1",
    d: "M1297.11 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    className: "cls-1",
    d: "M1297.11 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    className: "cls-1",
    d: "M1284.34 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    className: "cls-1",
    d: "M1284.34 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    className: "cls-1",
    d: "M1284.34 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    className: "cls-1",
    d: "M1284.34 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    className: "cls-1",
    d: "M1284.34 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    className: "cls-1",
    d: "M1284.34 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    className: "cls-1",
    d: "M1284.34 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    className: "cls-1",
    d: "M1284.34 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    className: "cls-1",
    d: "M1284.34 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    className: "cls-1",
    d: "M1284.34 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    className: "cls-1",
    d: "M1284.34 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    className: "cls-1",
    d: "M1284.34 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    className: "cls-1",
    d: "M1284.34 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    className: "cls-1",
    d: "M1284.34 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    className: "cls-1",
    d: "M1284.34 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    className: "cls-1",
    d: "M1284.34 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    className: "cls-1",
    d: "M1284.34 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    className: "cls-1",
    d: "M1284.34 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    className: "cls-1",
    d: "M1284.34 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    className: "cls-1",
    d: "M1284.34 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    className: "cls-1",
    d: "M1284.34 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    className: "cls-1",
    d: "M1284.34 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    className: "cls-1",
    d: "M1284.34 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    className: "cls-1",
    d: "M1284.34 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    className: "cls-1",
    d: "M1284.34 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    className: "cls-1",
    d: "M1284.34 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    className: "cls-1",
    d: "M1284.34 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    className: "cls-1",
    d: "M1284.34 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    className: "cls-1",
    d: "M1271.57 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    className: "cls-1",
    d: "M1271.57 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    className: "cls-1",
    d: "M1271.57 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    className: "cls-1",
    d: "M1271.57 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    className: "cls-1",
    d: "M1271.57 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    className: "cls-1",
    d: "M1271.57 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    className: "cls-1",
    d: "M1271.57 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    className: "cls-1",
    d: "M1271.57 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    className: "cls-1",
    d: "M1271.57 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    className: "cls-1",
    d: "M1271.57 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    className: "cls-1",
    d: "M1271.57 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    className: "cls-1",
    d: "M1271.57 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-1",
    d: "M1271.57 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    className: "cls-1",
    d: "M1271.57 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-1",
    d: "M1271.57 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    className: "cls-1",
    d: "M1271.57 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    className: "cls-1",
    d: "M1271.57 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-1",
    d: "M1271.57 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    className: "cls-1",
    d: "M1271.57 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    className: "cls-1",
    d: "M1271.57 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    className: "cls-1",
    d: "M1271.57 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    className: "cls-1",
    d: "M1271.57 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    className: "cls-1",
    d: "M1271.57 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    className: "cls-1",
    d: "M1271.57 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-1",
    d: "M1271.57 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-1",
    d: "M1271.57 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-1",
    d: "M1271.57 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-1",
    d: "M1271.57 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-1",
    d: "M1271.57 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-1",
    d: "M1258.8 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-1",
    d: "M1258.8 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-1",
    d: "M1258.8 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-1",
    d: "M1258.8 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-1",
    d: "M1258.8 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-1",
    d: "M1258.8 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-1",
    d: "M1258.8 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-1",
    d: "M1258.8 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-1",
    d: "M1258.8 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-1",
    d: "M1258.8 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    className: "cls-1",
    d: "M1258.8 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-1",
    d: "M1258.8 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    className: "cls-1",
    d: "M1258.8 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    className: "cls-1",
    d: "M1258.8 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-1",
    d: "M1258.8 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-1",
    d: "M1258.8 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-1",
    d: "M1258.8 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-1",
    d: "M1258.8 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    className: "cls-1",
    d: "M1258.8 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    className: "cls-1",
    d: "M1258.8 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-1",
    d: "M1258.8 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    className: "cls-1",
    d: "M1258.8 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    className: "cls-1",
    d: "M1258.8 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-1",
    d: "M1258.8 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-1",
    d: "M1258.8 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    className: "cls-1",
    d: "M1258.8 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    className: "cls-1",
    d: "M1258.8 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    className: "cls-1",
    d: "M1258.8 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    className: "cls-1",
    d: "M1258.8 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    className: "cls-1",
    d: "M1258.8 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    className: "cls-1",
    d: "M1258.8 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    className: "cls-1",
    d: "M1258.8 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-1",
    d: "M1246 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-1",
    d: "M1246 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-1",
    d: "M1246 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    className: "cls-1",
    d: "M1246 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-1",
    d: "M1246 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-1",
    d: "M1246 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-1",
    d: "M1246 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-1",
    d: "M1246 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-1",
    d: "M1246 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-1",
    d: "M1246 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    className: "cls-1",
    d: "M1246 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    className: "cls-1",
    d: "M1246 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    className: "cls-1",
    d: "M1246 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    className: "cls-1",
    d: "M1246 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    className: "cls-1",
    d: "M1246 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-1",
    d: "M1246 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-1",
    d: "M1246 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-1",
    d: "M1246 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-1",
    d: "M1246 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-1",
    d: "M1246 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-1",
    d: "M1246 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-1",
    d: "M1246 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-1",
    d: "M1246 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-1",
    d: "M1246 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-1",
    d: "M1246 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    className: "cls-1",
    d: "M1246 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    className: "cls-1",
    d: "M1246 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    className: "cls-1",
    d: "M1246 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    className: "cls-1",
    d: "M1246 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    className: "cls-1",
    d: "M1246 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    className: "cls-1",
    d: "M1246 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    className: "cls-1",
    d: "M1246 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    className: "cls-1",
    d: "M1246 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    className: "cls-1",
    d: "M1246 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    className: "cls-1",
    d: "M1233.26 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    className: "cls-1",
    d: "M1233.26 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    className: "cls-1",
    d: "M1233.26 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    className: "cls-1",
    d: "M1233.26 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    className: "cls-1",
    d: "M1233.26 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    className: "cls-1",
    d: "M1233.26 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-1",
    d: "M1233.26 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-1",
    d: "M1233.26 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-1",
    d: "M1233.26 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-1",
    d: "M1233.26 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-1",
    d: "M1233.26 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-1",
    d: "M1233.26 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-1",
    d: "M1233.26 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-1",
    d: "M1233.26 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-1",
    d: "M1233.26 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-1",
    d: "M1233.26 330a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-1",
    d: "M1233.26 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-1",
    d: "M1233.26 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-1",
    d: "M1233.26 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-1",
    d: "M1233.26 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-1",
    d: "M1233.26 393.78a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-1",
    d: "M1233.26 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-1",
    d: "M1233.26 419.31a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-1",
    d: "M1233.26 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-1",
    d: "M1233.26 457.61a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-1",
    d: "M1233.26 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-1",
    d: "M1233.26 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-1",
    d: "M1233.26 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-1",
    d: "M1233.26 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-1",
    d: "M1233.26 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-1",
    d: "M1233.26 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-1",
    d: "M1233.26 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-1",
    d: "M1233.26 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-1",
    d: "M1233.26 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-1",
    d: "M1233.26 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-1",
    d: "M1233.26 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-1",
    d: "M1233.26 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-1",
    d: "M1233.26 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-1",
    d: "M1220.48 138.46a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-1",
    d: "M1220.48 151.23a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-1",
    d: "M1220.48 164a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-1",
    d: "M1220.48 176.76a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-1",
    d: "M1220.48 189.53a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-1",
    d: "M1220.48 202.29a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-1",
    d: "M1220.48 215.06a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-1",
    d: "M1220.48 227.82a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-1",
    d: "M1220.48 240.59a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-1",
    d: "M1220.48 253.36a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-1",
    d: "M1220.48 266.12a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    className: "cls-1",
    d: "M1220.48 278.89a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-1",
    d: "M1220.48 291.65a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-1",
    d: "M1220.48 304.42a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-1",
    d: "M1220.48 317.19a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-1",
    d: "M1220.48 330a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-1",
    d: "M1220.48 342.72a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-1",
    d: "M1220.48 355.49a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-1",
    d: "M1220.48 368.25a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-1",
    d: "M1220.48 381a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-1",
    d: "M1220.48 393.78a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-1",
    d: "M1220.48 406.55a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-1",
    d: "M1220.48 419.31a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-1",
    d: "M1220.48 495.91a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-1",
    d: "M1220.48 508.68a3.6 3.6 0 11-3.59-3.6 3.59 3.59 0 013.59 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-1",
    d: "M1220.48 521.45a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-1",
    d: "M1220.48 534.21a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-1",
    d: "M1220.48 559.74a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-1",
    d: "M1220.48 623.58a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-1",
    d: "M1220.48 636.34a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-1",
    d: "M1220.48 649.11a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-1",
    d: "M1220.48 661.87a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-1",
    d: "M1220.48 674.64a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-1",
    d: "M1207.71 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-1",
    d: "M1207.71 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-1",
    d: "M1207.71 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-1",
    d: "M1207.71 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-1",
    d: "M1207.71 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-1",
    d: "M1207.71 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-1",
    d: "M1207.71 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-1",
    d: "M1207.71 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    className: "cls-1",
    d: "M1207.71 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-1",
    d: "M1207.71 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    className: "cls-1",
    d: "M1207.71 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-1",
    d: "M1207.71 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-1",
    d: "M1207.71 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-1",
    d: "M1207.71 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-1",
    d: "M1207.71 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-1",
    d: "M1207.71 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-1",
    d: "M1207.71 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-1",
    d: "M1207.71 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-1",
    d: "M1207.71 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-1",
    d: "M1207.71 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-1",
    d: "M1207.71 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-1",
    d: "M1207.71 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-1",
    d: "M1207.71 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-1",
    d: "M1207.71 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-1",
    d: "M1207.71 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    className: "cls-1",
    d: "M1207.71 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    className: "cls-1",
    d: "M1207.71 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-1",
    d: "M1207.71 534.21a3.6 3.6 0 11-3.6-3.6 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-1",
    d: "M1207.71 559.74a3.6 3.6 0 11-3.6-3.6 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-1",
    d: "M1207.71 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-1",
    d: "M1207.71 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-1",
    d: "M1207.71 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-1",
    d: "M1194.94 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-1",
    d: "M1194.94 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-1",
    d: "M1194.94 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-1",
    d: "M1194.94 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-1",
    d: "M1194.94 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-1",
    d: "M1194.94 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-1",
    d: "M1194.94 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-1",
    d: "M1194.94 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-1",
    d: "M1194.94 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-1",
    d: "M1194.94 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-1",
    d: "M1194.94 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-1",
    d: "M1194.94 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-1",
    d: "M1194.94 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-1",
    d: "M1194.94 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-1",
    d: "M1194.94 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-1",
    d: "M1194.94 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-1",
    d: "M1194.94 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-1",
    d: "M1194.94 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-1",
    d: "M1194.94 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-1",
    d: "M1194.94 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-1",
    d: "M1194.94 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-1",
    d: "M1194.94 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-1",
    d: "M1194.94 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-1",
    d: "M1194.94 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-1",
    d: "M1194.94 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    className: "cls-1",
    d: "M1194.94 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-1",
    d: "M1194.94 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-1",
    d: "M1194.94 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-1",
    d: "M1194.94 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-1",
    d: "M1194.94 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    className: "cls-1",
    d: "M1182.17 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-1",
    d: "M1182.17 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    className: "cls-1",
    d: "M1182.17 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    className: "cls-1",
    d: "M1182.17 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    className: "cls-1",
    d: "M1182.17 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    className: "cls-1",
    d: "M1182.17 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    className: "cls-1",
    d: "M1182.17 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    className: "cls-1",
    d: "M1182.17 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    className: "cls-1",
    d: "M1182.17 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    className: "cls-1",
    d: "M1182.17 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    className: "cls-1",
    d: "M1182.17 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    className: "cls-1",
    d: "M1182.17 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    className: "cls-1",
    d: "M1182.17 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    className: "cls-1",
    d: "M1182.17 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    className: "cls-1",
    d: "M1182.17 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    className: "cls-1",
    d: "M1182.17 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    className: "cls-1",
    d: "M1182.17 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    className: "cls-1",
    d: "M1182.17 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    className: "cls-1",
    d: "M1182.17 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    className: "cls-1",
    d: "M1182.17 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    className: "cls-1",
    d: "M1182.17 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    className: "cls-1",
    d: "M1182.17 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    className: "cls-1",
    d: "M1182.17 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-1",
    d: "M1182.17 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-1",
    d: "M1182.17 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-1",
    d: "M1182.17 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-1",
    d: "M1182.17 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-1",
    d: "M1182.17 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    className: "cls-1",
    d: "M1182.17 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    className: "cls-1",
    d: "M1182.17 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    className: "cls-1",
    d: "M1169.4 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    className: "cls-1",
    d: "M1169.4 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    className: "cls-1",
    d: "M1169.4 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    className: "cls-1",
    d: "M1169.4 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    className: "cls-1",
    d: "M1169.4 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    className: "cls-1",
    d: "M1169.4 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    className: "cls-1",
    d: "M1169.4 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    className: "cls-1",
    d: "M1169.4 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    className: "cls-1",
    d: "M1169.4 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    className: "cls-1",
    d: "M1169.4 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    className: "cls-1",
    d: "M1169.4 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    className: "cls-1",
    d: "M1169.4 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    className: "cls-1",
    d: "M1169.4 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    className: "cls-1",
    d: "M1169.4 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    className: "cls-1",
    d: "M1169.4 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    className: "cls-1",
    d: "M1169.4 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    className: "cls-1",
    d: "M1169.4 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    className: "cls-1",
    d: "M1169.4 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    className: "cls-1",
    d: "M1169.4 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    className: "cls-1",
    d: "M1169.4 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    className: "cls-1",
    d: "M1169.4 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    className: "cls-1",
    d: "M1169.4 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    className: "cls-1",
    d: "M1169.4 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    className: "cls-1",
    d: "M1169.4 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    className: "cls-1",
    d: "M1169.4 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    className: "cls-1",
    d: "M1169.4 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    className: "cls-1",
    d: "M1169.4 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    className: "cls-1",
    d: "M1169.4 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    className: "cls-1",
    d: "M1169.4 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    className: "cls-1",
    d: "M1169.4 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    className: "cls-1",
    d: "M1169.4 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    className: "cls-1",
    d: "M1169.4 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    className: "cls-1",
    d: "M1169.4 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    className: "cls-1",
    d: "M1169.4 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    className: "cls-1",
    d: "M1169.4 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    className: "cls-1",
    d: "M1169.4 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    className: "cls-1",
    d: "M1156.63 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    className: "cls-1",
    d: "M1156.63 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    className: "cls-1",
    d: "M1156.63 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    className: "cls-1",
    d: "M1156.63 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    className: "cls-1",
    d: "M1156.63 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    className: "cls-1",
    d: "M1156.63 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    className: "cls-1",
    d: "M1156.63 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    className: "cls-1",
    d: "M1156.63 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    className: "cls-1",
    d: "M1156.63 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    className: "cls-1",
    d: "M1156.63 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    className: "cls-1",
    d: "M1156.63 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    className: "cls-1",
    d: "M1156.63 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    className: "cls-1",
    d: "M1156.63 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    className: "cls-1",
    d: "M1156.63 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    className: "cls-1",
    d: "M1156.63 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    className: "cls-1",
    d: "M1156.63 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    className: "cls-1",
    d: "M1156.63 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    className: "cls-1",
    d: "M1156.63 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    className: "cls-1",
    d: "M1156.63 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-1",
    d: "M1156.63 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-1",
    d: "M1156.63 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-1",
    d: "M1156.63 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    className: "cls-1",
    d: "M1156.63 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    className: "cls-1",
    d: "M1156.63 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    className: "cls-1",
    d: "M1156.63 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    className: "cls-1",
    d: "M1156.63 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    className: "cls-1",
    d: "M1156.63 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    className: "cls-1",
    d: "M1156.63 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    className: "cls-1",
    d: "M1156.63 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    className: "cls-1",
    d: "M1156.63 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    className: "cls-1",
    d: "M1156.63 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    className: "cls-1",
    d: "M1156.63 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    className: "cls-1",
    d: "M1156.63 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    className: "cls-1",
    d: "M1156.63 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    className: "cls-1",
    d: "M1156.63 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    className: "cls-1",
    d: "M1143.85 74.63a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    className: "cls-1",
    d: "M1143.85 87.4a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    className: "cls-1",
    d: "M1143.85 112.93a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    className: "cls-1",
    d: "M1143.85 125.7a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    className: "cls-1",
    d: "M1143.85 138.46a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    className: "cls-1",
    d: "M1143.85 151.23a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    className: "cls-1",
    d: "M1143.85 164a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    className: "cls-1",
    d: "M1143.85 176.76a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    className: "cls-1",
    d: "M1143.85 189.53a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    className: "cls-1",
    d: "M1143.85 202.29a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    className: "cls-1",
    d: "M1143.85 215.06a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    className: "cls-1",
    d: "M1143.85 227.82a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    className: "cls-1",
    d: "M1143.85 240.59a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    className: "cls-1",
    d: "M1143.85 253.36a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    className: "cls-1",
    d: "M1143.85 266.12a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    className: "cls-1",
    d: "M1143.85 278.89a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    className: "cls-1",
    d: "M1143.85 291.65a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    className: "cls-1",
    d: "M1143.85 304.42a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    className: "cls-1",
    d: "M1143.85 317.19a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    className: "cls-1",
    d: "M1143.85 330a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    className: "cls-1",
    d: "M1143.85 342.72a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    className: "cls-1",
    d: "M1143.85 355.49a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    className: "cls-1",
    d: "M1143.85 368.25a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    className: "cls-1",
    d: "M1143.85 381a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    className: "cls-1",
    d: "M1143.85 393.78a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    className: "cls-1",
    d: "M1143.85 406.55a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    className: "cls-1",
    d: "M1143.85 419.31a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    className: "cls-1",
    d: "M1143.85 432.08a3.6 3.6 0 11-3.59-3.6 3.59 3.59 0 013.59 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    className: "cls-1",
    d: "M1143.85 444.85a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    className: "cls-1",
    d: "M1143.85 457.61a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    className: "cls-1",
    d: "M1143.85 470.38a3.6 3.6 0 11-3.59-3.6 3.59 3.59 0 013.59 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    className: "cls-1",
    d: "M1143.85 483.15a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    className: "cls-1",
    d: "M1143.85 495.91a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    className: "cls-1",
    d: "M1143.85 508.68a3.6 3.6 0 11-3.59-3.6 3.59 3.59 0 013.59 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    className: "cls-1",
    d: "M1143.85 521.45a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    className: "cls-1",
    d: "M1131.09 61.87a3.6 3.6 0 11-3.61-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    className: "cls-1",
    d: "M1131.09 74.63a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-1",
    d: "M1131.09 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    className: "cls-1",
    d: "M1131.09 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    className: "cls-1",
    d: "M1131.09 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    className: "cls-1",
    d: "M1131.09 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    className: "cls-1",
    d: "M1131.09 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    className: "cls-1",
    d: "M1131.09 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    className: "cls-1",
    d: "M1131.09 176.76a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    className: "cls-1",
    d: "M1131.09 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    className: "cls-1",
    d: "M1131.09 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    className: "cls-1",
    d: "M1131.09 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    className: "cls-1",
    d: "M1131.09 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    className: "cls-1",
    d: "M1131.09 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    className: "cls-1",
    d: "M1131.09 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    className: "cls-1",
    d: "M1131.09 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    className: "cls-1",
    d: "M1131.09 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    className: "cls-1",
    d: "M1131.09 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    className: "cls-1",
    d: "M1131.09 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    className: "cls-1",
    d: "M1131.09 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    className: "cls-1",
    d: "M1131.09 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    className: "cls-1",
    d: "M1131.09 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    className: "cls-1",
    d: "M1131.09 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    className: "cls-1",
    d: "M1131.09 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    className: "cls-1",
    d: "M1131.09 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    className: "cls-1",
    d: "M1131.09 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    className: "cls-1",
    d: "M1131.09 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    className: "cls-1",
    d: "M1131.09 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    className: "cls-1",
    d: "M1131.09 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    className: "cls-1",
    d: "M1131.09 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    className: "cls-1",
    d: "M1131.09 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    className: "cls-1",
    d: "M1118.31 74.63a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    className: "cls-1",
    d: "M1118.31 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    className: "cls-1",
    d: "M1118.31 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    className: "cls-1",
    d: "M1118.31 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    className: "cls-1",
    d: "M1118.31 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    className: "cls-1",
    d: "M1118.31 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    className: "cls-1",
    d: "M1118.31 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    className: "cls-1",
    d: "M1118.31 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    className: "cls-1",
    d: "M1118.31 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    className: "cls-1",
    d: "M1118.31 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    className: "cls-1",
    d: "M1118.31 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    className: "cls-1",
    d: "M1118.31 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    className: "cls-1",
    d: "M1118.31 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    className: "cls-1",
    d: "M1118.31 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    className: "cls-1",
    d: "M1118.31 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    className: "cls-1",
    d: "M1118.31 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    className: "cls-1",
    d: "M1118.31 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    className: "cls-1",
    d: "M1118.31 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    className: "cls-1",
    d: "M1118.31 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    className: "cls-1",
    d: "M1118.31 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    className: "cls-1",
    d: "M1118.31 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    className: "cls-1",
    d: "M1118.31 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    className: "cls-1",
    d: "M1118.31 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    className: "cls-1",
    d: "M1118.31 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    className: "cls-1",
    d: "M1118.31 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    className: "cls-1",
    d: "M1118.31 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    className: "cls-1",
    d: "M1118.31 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    className: "cls-1",
    d: "M1105.54 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    className: "cls-1",
    d: "M1105.54 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    className: "cls-1",
    d: "M1105.54 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    className: "cls-1",
    d: "M1105.54 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    className: "cls-1",
    d: "M1105.54 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    className: "cls-1",
    d: "M1105.54 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    className: "cls-1",
    d: "M1105.54 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    className: "cls-1",
    d: "M1105.54 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    className: "cls-1",
    d: "M1105.54 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    className: "cls-1",
    d: "M1105.54 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    className: "cls-1",
    d: "M1105.54 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    className: "cls-1",
    d: "M1105.54 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    className: "cls-1",
    d: "M1105.54 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    className: "cls-1",
    d: "M1105.54 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    className: "cls-1",
    d: "M1105.54 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    className: "cls-1",
    d: "M1105.54 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    className: "cls-1",
    d: "M1105.54 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    className: "cls-1",
    d: "M1105.54 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    className: "cls-1",
    d: "M1105.54 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    className: "cls-1",
    d: "M1105.54 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    className: "cls-1",
    d: "M1105.54 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    className: "cls-1",
    d: "M1105.54 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    className: "cls-1",
    d: "M1105.54 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    className: "cls-1",
    d: "M1105.54 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    className: "cls-1",
    d: "M1105.54 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    className: "cls-1",
    d: "M1092.78 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    className: "cls-1",
    d: "M1092.78 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    className: "cls-1",
    d: "M1092.78 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    className: "cls-1",
    d: "M1092.78 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    className: "cls-1",
    d: "M1092.78 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    className: "cls-1",
    d: "M1092.78 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    className: "cls-1",
    d: "M1092.78 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    className: "cls-1",
    d: "M1092.78 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    className: "cls-1",
    d: "M1092.78 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    className: "cls-1",
    d: "M1092.78 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    className: "cls-1",
    d: "M1092.78 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    className: "cls-1",
    d: "M1092.78 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    className: "cls-1",
    d: "M1092.78 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    className: "cls-1",
    d: "M1092.78 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    className: "cls-1",
    d: "M1092.78 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    className: "cls-1",
    d: "M1092.78 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    className: "cls-1",
    d: "M1092.78 330a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    className: "cls-1",
    d: "M1092.78 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    className: "cls-1",
    d: "M1092.78 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    className: "cls-1",
    d: "M1092.78 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    className: "cls-1",
    d: "M1092.78 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    className: "cls-1",
    d: "M1092.78 393.78a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    className: "cls-1",
    d: "M1092.78 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    className: "cls-1",
    d: "M1092.78 419.31a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    className: "cls-1",
    d: "M1092.78 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    className: "cls-1",
    d: "M1080 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    className: "cls-1",
    d: "M1080 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    className: "cls-1",
    d: "M1080 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    className: "cls-1",
    d: "M1080 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    className: "cls-1",
    d: "M1080 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    className: "cls-1",
    d: "M1080 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    className: "cls-1",
    d: "M1080 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    className: "cls-1",
    d: "M1080 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    className: "cls-1",
    d: "M1080 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    className: "cls-1",
    d: "M1080 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    className: "cls-1",
    d: "M1080 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    className: "cls-1",
    d: "M1080 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    className: "cls-1",
    d: "M1080 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    className: "cls-1",
    d: "M1080 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    className: "cls-1",
    d: "M1080 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    className: "cls-1",
    d: "M1080 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    className: "cls-1",
    d: "M1080 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    className: "cls-1",
    d: "M1080 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    className: "cls-1",
    d: "M1080 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    className: "cls-1",
    d: "M1080 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    className: "cls-1",
    d: "M1080 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    className: "cls-1",
    d: "M1080 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    className: "cls-1",
    d: "M1080 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    className: "cls-1",
    d: "M1080 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    className: "cls-1",
    d: "M1080 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    className: "cls-1",
    d: "M1067.23 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    className: "cls-1",
    d: "M1067.23 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    className: "cls-1",
    d: "M1067.23 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    className: "cls-1",
    d: "M1067.23 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    className: "cls-1",
    d: "M1067.23 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    className: "cls-1",
    d: "M1067.23 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    className: "cls-1",
    d: "M1067.23 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    className: "cls-1",
    d: "M1067.23 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    className: "cls-1",
    d: "M1067.23 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    className: "cls-1",
    d: "M1067.23 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    className: "cls-1",
    d: "M1067.23 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    className: "cls-1",
    d: "M1067.23 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    className: "cls-1",
    d: "M1067.23 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    className: "cls-1",
    d: "M1067.23 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    className: "cls-1",
    d: "M1067.23 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    className: "cls-1",
    d: "M1067.23 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    className: "cls-1",
    d: "M1067.23 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    className: "cls-1",
    d: "M1067.23 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    className: "cls-1",
    d: "M1067.23 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    className: "cls-1",
    d: "M1067.23 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    className: "cls-1",
    d: "M1067.23 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    className: "cls-1",
    d: "M1067.23 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    className: "cls-1",
    d: "M1067.23 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    className: "cls-1",
    d: "M1067.23 432.08a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    className: "cls-1",
    d: "M1067.23 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    className: "cls-1",
    d: "M1067.23 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    className: "cls-1",
    d: "M1067.23 470.38a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    className: "cls-1",
    d: "M1067.23 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    className: "cls-1",
    d: "M1054.46 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    className: "cls-1",
    d: "M1054.46 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    className: "cls-1",
    d: "M1054.46 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    className: "cls-1",
    d: "M1054.46 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    className: "cls-1",
    d: "M1054.46 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    className: "cls-1",
    d: "M1054.46 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    className: "cls-1",
    d: "M1054.46 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    className: "cls-1",
    d: "M1054.46 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    className: "cls-1",
    d: "M1054.46 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    className: "cls-1",
    d: "M1054.46 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    className: "cls-1",
    d: "M1054.46 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    className: "cls-1",
    d: "M1054.46 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    className: "cls-1",
    d: "M1054.46 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    className: "cls-1",
    d: "M1054.46 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    className: "cls-1",
    d: "M1054.46 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    className: "cls-1",
    d: "M1054.46 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    className: "cls-1",
    d: "M1054.46 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    className: "cls-1",
    d: "M1054.46 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    className: "cls-1",
    d: "M1054.46 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    className: "cls-1",
    d: "M1054.46 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    className: "cls-1",
    d: "M1054.46 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    className: "cls-1",
    d: "M1054.46 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    className: "cls-1",
    d: "M1054.46 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    className: "cls-1",
    d: "M1054.46 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    className: "cls-1",
    d: "M1054.46 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    className: "cls-1",
    d: "M1054.46 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    className: "cls-1",
    d: "M1054.46 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    className: "cls-1",
    d: "M1054.46 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    className: "cls-1",
    d: "M1041.69 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-1",
    d: "M1041.69 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-1",
    d: "M1041.69 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-1",
    d: "M1041.69 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-1",
    d: "M1041.69 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-1",
    d: "M1041.69 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-1",
    d: "M1041.69 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-1",
    d: "M1041.69 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-1",
    d: "M1041.69 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-1",
    d: "M1041.69 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-1",
    d: "M1041.69 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-1",
    d: "M1041.69 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-1",
    d: "M1041.69 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-1",
    d: "M1041.69 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-1",
    d: "M1041.69 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-1",
    d: "M1041.69 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-1",
    d: "M1041.69 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-1",
    d: "M1041.69 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-1",
    d: "M1041.69 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-1",
    d: "M1041.69 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-1",
    d: "M1041.69 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-1",
    d: "M1041.69 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-1",
    d: "M1041.69 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-1",
    d: "M1041.69 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-1",
    d: "M1041.69 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-1",
    d: "M1041.69 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-1",
    d: "M1041.69 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-1",
    d: "M1028.91 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-1",
    d: "M1028.91 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-1",
    d: "M1028.91 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-1",
    d: "M1028.91 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-1",
    d: "M1028.91 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-1",
    d: "M1028.91 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-1",
    d: "M1028.91 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-1",
    d: "M1028.91 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-1",
    d: "M1028.91 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    className: "cls-1",
    d: "M1028.91 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    className: "cls-1",
    d: "M1028.91 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    className: "cls-1",
    d: "M1028.91 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    className: "cls-1",
    d: "M1028.91 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    className: "cls-1",
    d: "M1028.91 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    className: "cls-1",
    d: "M1028.91 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    className: "cls-1",
    d: "M1028.91 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    className: "cls-1",
    d: "M1028.91 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    className: "cls-1",
    d: "M1028.91 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-1",
    d: "M1028.91 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    className: "cls-1",
    d: "M1028.91 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    className: "cls-1",
    d: "M1028.91 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    className: "cls-1",
    d: "M1028.91 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    className: "cls-1",
    d: "M1028.91 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    className: "cls-1",
    d: "M1028.91 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    className: "cls-1",
    d: "M1016.14 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    className: "cls-1",
    d: "M1016.14 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    className: "cls-1",
    d: "M1016.14 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    className: "cls-1",
    d: "M1016.14 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    className: "cls-1",
    d: "M1016.14 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    className: "cls-1",
    d: "M1016.14 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    className: "cls-1",
    d: "M1016.14 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    className: "cls-1",
    d: "M1016.14 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    className: "cls-1",
    d: "M1016.14 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    className: "cls-1",
    d: "M1016.14 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    className: "cls-1",
    d: "M1016.14 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    className: "cls-1",
    d: "M1016.14 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    className: "cls-1",
    d: "M1016.14 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    className: "cls-1",
    d: "M1016.14 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    className: "cls-1",
    d: "M1016.14 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    className: "cls-1",
    d: "M1016.14 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    className: "cls-1",
    d: "M1016.14 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-1",
    d: "M1016.14 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-1",
    d: "M1016.14 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-1",
    d: "M1016.14 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-1",
    d: "M1016.14 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-1",
    d: "M1016.14 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    className: "cls-1",
    d: "M1016.14 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    className: "cls-1",
    d: "M1016.14 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    className: "cls-1",
    d: "M1016.14 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    className: "cls-1",
    d: "M1003.37 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    className: "cls-1",
    d: "M1003.37 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    className: "cls-1",
    d: "M1003.37 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    className: "cls-1",
    d: "M1003.37 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    className: "cls-1",
    d: "M1003.37 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-1",
    d: "M1003.37 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    className: "cls-1",
    d: "M1003.37 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-1",
    d: "M1003.37 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-1",
    d: "M1003.37 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-1",
    d: "M1003.37 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-1",
    d: "M1003.37 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    className: "cls-1",
    d: "M1003.37 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-1",
    d: "M1003.37 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-1",
    d: "M1003.37 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-1",
    d: "M1003.37 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-1",
    d: "M1003.37 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-1",
    d: "M1003.37 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    className: "cls-1",
    d: "M1003.37 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    className: "cls-1",
    d: "M1003.37 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    className: "cls-1",
    d: "M1003.37 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    className: "cls-1",
    d: "M1003.37 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    className: "cls-1",
    d: "M1003.37 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    className: "cls-1",
    d: "M990.6 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    className: "cls-1",
    d: "M990.6 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    className: "cls-1",
    d: "M990.6 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    className: "cls-1",
    d: "M990.6 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    className: "cls-1",
    d: "M990.6 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    className: "cls-1",
    d: "M990.6 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    className: "cls-1",
    d: "M990.6 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    className: "cls-1",
    d: "M990.6 240.59A3.6 3.6 0 11987 237a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    className: "cls-1",
    d: "M990.6 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    className: "cls-1",
    d: "M990.6 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    className: "cls-1",
    d: "M990.6 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    className: "cls-1",
    d: "M990.6 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    className: "cls-1",
    d: "M990.6 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    className: "cls-1",
    d: "M990.6 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    className: "cls-1",
    d: "M990.6 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    className: "cls-1",
    d: "M990.6 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    className: "cls-1",
    d: "M990.6 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    className: "cls-1",
    d: "M990.6 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    className: "cls-1",
    d: "M990.6 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    className: "cls-1",
    d: "M990.6 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    className: "cls-1",
    d: "M990.6 406.55A3.6 3.6 0 11987 403a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    className: "cls-1",
    d: "M977.83 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    className: "cls-1",
    d: "M977.83 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    className: "cls-1",
    d: "M977.83 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    className: "cls-1",
    d: "M977.83 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    className: "cls-1",
    d: "M977.83 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    className: "cls-1",
    d: "M977.83 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    className: "cls-1",
    d: "M977.83 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    className: "cls-1",
    d: "M977.83 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    className: "cls-1",
    d: "M977.83 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    className: "cls-1",
    d: "M977.83 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    className: "cls-1",
    d: "M977.83 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    className: "cls-1",
    d: "M977.83 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    className: "cls-1",
    d: "M977.83 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    className: "cls-1",
    d: "M977.83 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    className: "cls-1",
    d: "M977.83 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    className: "cls-1",
    d: "M977.83 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    className: "cls-1",
    d: "M977.83 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    className: "cls-1",
    d: "M977.83 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    className: "cls-1",
    d: "M977.83 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    className: "cls-1",
    d: "M977.83 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    className: "cls-1",
    d: "M977.83 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    className: "cls-1",
    d: "M977.83 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    className: "cls-1",
    d: "M965.06 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    className: "cls-1",
    d: "M965.06 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    className: "cls-1",
    d: "M965.06 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    className: "cls-1",
    d: "M965.06 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    className: "cls-1",
    d: "M965.06 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    className: "cls-1",
    d: "M965.06 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    className: "cls-1",
    d: "M965.06 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    className: "cls-1",
    d: "M965.06 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    className: "cls-1",
    d: "M965.06 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    className: "cls-1",
    d: "M965.06 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    className: "cls-1",
    d: "M965.06 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    className: "cls-1",
    d: "M965.06 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    className: "cls-1",
    d: "M965.06 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    className: "cls-1",
    d: "M965.06 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    className: "cls-1",
    d: "M965.06 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    className: "cls-1",
    d: "M965.06 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    className: "cls-1",
    d: "M965.06 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    className: "cls-1",
    d: "M965.06 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    className: "cls-1",
    d: "M965.06 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    className: "cls-1",
    d: "M965.06 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    className: "cls-1",
    d: "M965.06 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    className: "cls-1",
    d: "M965.06 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    className: "cls-1",
    d: "M965.06 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    className: "cls-1",
    d: "M952.29 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    className: "cls-1",
    d: "M952.29 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    className: "cls-1",
    d: "M952.29 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    className: "cls-1",
    d: "M952.29 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    className: "cls-1",
    d: "M952.29 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    className: "cls-1",
    d: "M952.29 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    className: "cls-1",
    d: "M952.29 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    className: "cls-1",
    d: "M952.29 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    className: "cls-1",
    d: "M952.29 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    className: "cls-1",
    d: "M952.29 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    className: "cls-1",
    d: "M952.29 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    className: "cls-1",
    d: "M952.29 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    className: "cls-1",
    d: "M952.29 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    className: "cls-1",
    d: "M952.29 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    className: "cls-1",
    d: "M952.29 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    className: "cls-1",
    d: "M952.29 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    className: "cls-1",
    d: "M952.29 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    className: "cls-1",
    d: "M952.29 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    className: "cls-1",
    d: "M952.29 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    className: "cls-1",
    d: "M952.29 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    className: "cls-1",
    d: "M952.29 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    className: "cls-1",
    d: "M952.29 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    className: "cls-1",
    d: "M952.29 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    className: "cls-1",
    d: "M939.52 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    className: "cls-1",
    d: "M939.52 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    className: "cls-1",
    d: "M939.52 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    className: "cls-1",
    d: "M939.52 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    className: "cls-1",
    d: "M939.52 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    className: "cls-1",
    d: "M939.52 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    className: "cls-1",
    d: "M939.52 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    className: "cls-1",
    d: "M939.52 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    className: "cls-1",
    d: "M939.52 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    className: "cls-1",
    d: "M939.52 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    className: "cls-1",
    d: "M939.52 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    className: "cls-1",
    d: "M939.52 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    className: "cls-1",
    d: "M939.52 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    className: "cls-1",
    d: "M939.52 330a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    className: "cls-1",
    d: "M939.52 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    className: "cls-1",
    d: "M939.52 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    className: "cls-1",
    d: "M939.52 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    className: "cls-1",
    d: "M939.52 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    className: "cls-1",
    d: "M939.52 393.78a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    className: "cls-1",
    d: "M939.52 419.31a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    className: "cls-1",
    d: "M939.52 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    className: "cls-1",
    d: "M939.52 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    className: "cls-1",
    d: "M939.52 457.61a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    className: "cls-1",
    d: "M939.52 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    className: "cls-1",
    d: "M939.52 495.91a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    className: "cls-1",
    d: "M939.52 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    className: "cls-1",
    d: "M926.74 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    className: "cls-1",
    d: "M926.74 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    className: "cls-1",
    d: "M926.74 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    className: "cls-1",
    d: "M926.74 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    className: "cls-1",
    d: "M926.74 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    className: "cls-1",
    d: "M926.74 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    className: "cls-1",
    d: "M926.74 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    className: "cls-1",
    d: "M926.74 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    className: "cls-1",
    d: "M926.74 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    className: "cls-1",
    d: "M926.74 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    className: "cls-1",
    d: "M926.74 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    className: "cls-1",
    d: "M926.74 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    className: "cls-1",
    d: "M926.74 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    className: "cls-1",
    d: "M926.74 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    className: "cls-1",
    d: "M926.74 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    className: "cls-1",
    d: "M926.74 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    className: "cls-1",
    d: "M926.74 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    className: "cls-1",
    d: "M926.74 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    className: "cls-1",
    d: "M926.74 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    className: "cls-1",
    d: "M926.74 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    className: "cls-1",
    d: "M926.74 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    className: "cls-1",
    d: "M926.74 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    className: "cls-1",
    d: "M926.74 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    className: "cls-1",
    d: "M926.74 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    className: "cls-1",
    d: "M926.74 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    className: "cls-1",
    d: "M926.74 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    className: "cls-1",
    d: "M926.74 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    className: "cls-1",
    d: "M926.74 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    className: "cls-1",
    d: "M926.74 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    className: "cls-1",
    d: "M926.74 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    className: "cls-1",
    d: "M914 176.76a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    className: "cls-1",
    d: "M914 189.53a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    className: "cls-1",
    d: "M914 202.29a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    className: "cls-1",
    d: "M914 215.06a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    className: "cls-1",
    d: "M914 227.82a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    className: "cls-1",
    d: "M914 240.59a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    className: "cls-1",
    d: "M914 253.36a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    className: "cls-1",
    d: "M914 266.12a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    className: "cls-1",
    d: "M914 278.89a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    className: "cls-1",
    d: "M914 291.65a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    className: "cls-1",
    d: "M914 304.42a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    className: "cls-1",
    d: "M914 317.19a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    className: "cls-1",
    d: "M914 330a3.6 3.6 0 11-3.59-3.6A3.6 3.6 0 01914 330"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    className: "cls-1",
    d: "M914 342.72a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    className: "cls-1",
    d: "M914 355.49a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    className: "cls-1",
    d: "M914 368.25a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    className: "cls-1",
    d: "M914 381a3.6 3.6 0 11-3.59-3.6A3.6 3.6 0 01914 381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    className: "cls-1",
    d: "M914 393.78a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    className: "cls-1",
    d: "M914 406.55a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    className: "cls-1",
    d: "M914 419.31a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    className: "cls-1",
    d: "M914 432.08a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    className: "cls-1",
    d: "M914 444.85a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    className: "cls-1",
    d: "M914 457.61a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    className: "cls-1",
    d: "M914 470.38a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    className: "cls-1",
    d: "M914 483.15a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    className: "cls-1",
    d: "M914 495.91a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    className: "cls-1",
    d: "M914 508.68a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    className: "cls-1",
    d: "M914 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    className: "cls-1",
    d: "M914 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    className: "cls-1",
    d: "M914 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    className: "cls-1",
    d: "M914 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    className: "cls-1",
    d: "M901.2 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    className: "cls-1",
    d: "M901.2 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    className: "cls-1",
    d: "M901.2 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    className: "cls-1",
    d: "M901.2 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    className: "cls-1",
    d: "M901.2 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    className: "cls-1",
    d: "M901.2 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    className: "cls-1",
    d: "M901.2 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    className: "cls-1",
    d: "M901.2 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    className: "cls-1",
    d: "M901.2 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    className: "cls-1",
    d: "M901.2 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    className: "cls-1",
    d: "M901.2 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    className: "cls-1",
    d: "M901.2 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    className: "cls-1",
    d: "M901.2 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    className: "cls-1",
    d: "M901.2 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    className: "cls-1",
    d: "M901.2 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    className: "cls-1",
    d: "M901.2 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    className: "cls-1",
    d: "M901.2 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    className: "cls-1",
    d: "M901.2 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    className: "cls-1",
    d: "M901.2 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    className: "cls-1",
    d: "M901.2 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    className: "cls-1",
    d: "M901.2 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    className: "cls-1",
    d: "M901.2 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    className: "cls-1",
    d: "M901.2 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    className: "cls-1",
    d: "M901.2 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    className: "cls-1",
    d: "M901.2 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    className: "cls-1",
    d: "M901.2 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    className: "cls-1",
    d: "M901.2 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    className: "cls-1",
    d: "M888.43 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    className: "cls-1",
    d: "M888.43 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    className: "cls-1",
    d: "M888.43 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    className: "cls-1",
    d: "M888.43 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    className: "cls-1",
    d: "M888.43 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    className: "cls-1",
    d: "M888.43 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    className: "cls-1",
    d: "M888.43 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    className: "cls-1",
    d: "M888.43 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    className: "cls-1",
    d: "M888.43 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    className: "cls-1",
    d: "M888.43 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    className: "cls-1",
    d: "M888.43 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    className: "cls-1",
    d: "M888.43 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    className: "cls-1",
    d: "M888.43 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    className: "cls-1",
    d: "M888.43 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    className: "cls-1",
    d: "M888.43 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    className: "cls-1",
    d: "M888.43 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    className: "cls-1",
    d: "M888.43 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    className: "cls-1",
    d: "M888.43 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    className: "cls-1",
    d: "M888.43 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    className: "cls-1",
    d: "M888.43 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    className: "cls-1",
    d: "M888.43 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    className: "cls-1",
    d: "M888.43 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    className: "cls-1",
    d: "M888.43 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    className: "cls-1",
    d: "M888.43 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    className: "cls-1",
    d: "M888.43 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    className: "cls-1",
    d: "M888.43 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    className: "cls-1",
    d: "M888.43 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    className: "cls-1",
    d: "M888.43 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    className: "cls-1",
    d: "M888.43 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    className: "cls-1",
    d: "M888.43 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    className: "cls-1",
    d: "M888.43 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    className: "cls-1",
    d: "M888.43 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    className: "cls-1",
    d: "M875.66 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    className: "cls-1",
    d: "M875.66 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    className: "cls-1",
    d: "M875.66 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    className: "cls-1",
    d: "M875.66 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    className: "cls-1",
    d: "M875.66 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    className: "cls-1",
    d: "M875.66 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    className: "cls-1",
    d: "M875.66 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    className: "cls-1",
    d: "M875.66 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    className: "cls-1",
    d: "M875.66 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    className: "cls-1",
    d: "M875.66 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    className: "cls-1",
    d: "M875.66 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    className: "cls-1",
    d: "M875.66 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    className: "cls-1",
    d: "M875.66 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    className: "cls-1",
    d: "M875.66 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    className: "cls-1",
    d: "M875.66 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    className: "cls-1",
    d: "M875.66 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    className: "cls-1",
    d: "M875.66 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    className: "cls-1",
    d: "M875.66 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    className: "cls-1",
    d: "M875.66 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    className: "cls-1",
    d: "M875.66 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    className: "cls-1",
    d: "M875.66 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    className: "cls-1",
    d: "M875.66 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    className: "cls-1",
    d: "M875.66 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    className: "cls-1",
    d: "M875.66 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    className: "cls-1",
    d: "M875.66 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    className: "cls-1",
    d: "M875.66 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    className: "cls-1",
    d: "M875.66 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    className: "cls-1",
    d: "M875.66 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    className: "cls-1",
    d: "M875.66 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    className: "cls-1",
    d: "M875.66 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    className: "cls-1",
    d: "M875.66 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    className: "cls-1",
    d: "M875.66 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    className: "cls-1",
    d: "M875.66 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    className: "cls-1",
    d: "M875.66 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    className: "cls-1",
    d: "M875.66 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    className: "cls-1",
    d: "M862.88 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    className: "cls-1",
    d: "M862.88 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    className: "cls-1",
    d: "M862.88 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    className: "cls-1",
    d: "M862.88 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    className: "cls-1",
    d: "M862.88 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    className: "cls-1",
    d: "M862.88 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    className: "cls-1",
    d: "M862.88 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    className: "cls-1",
    d: "M862.88 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    className: "cls-1",
    d: "M862.88 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    className: "cls-1",
    d: "M862.88 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    className: "cls-1",
    d: "M862.88 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    className: "cls-1",
    d: "M862.88 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    className: "cls-1",
    d: "M862.88 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    className: "cls-1",
    d: "M862.88 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    className: "cls-1",
    d: "M862.88 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    className: "cls-1",
    d: "M862.88 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    className: "cls-1",
    d: "M862.88 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    className: "cls-1",
    d: "M862.88 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    className: "cls-1",
    d: "M862.88 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    className: "cls-1",
    d: "M862.88 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    className: "cls-1",
    d: "M862.88 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    className: "cls-1",
    d: "M862.88 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    className: "cls-1",
    d: "M862.88 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    className: "cls-1",
    d: "M862.88 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    className: "cls-1",
    d: "M862.88 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    className: "cls-1",
    d: "M862.88 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    className: "cls-1",
    d: "M862.88 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    className: "cls-1",
    d: "M862.88 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    className: "cls-1",
    d: "M862.88 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    className: "cls-1",
    d: "M862.88 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    className: "cls-1",
    d: "M862.88 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    className: "cls-1",
    d: "M862.88 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    className: "cls-1",
    d: "M862.88 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    className: "cls-1",
    d: "M862.88 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    className: "cls-1",
    d: "M862.88 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    className: "cls-1",
    d: "M850.12 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    className: "cls-1",
    d: "M850.12 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    className: "cls-1",
    d: "M850.12 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    className: "cls-1",
    d: "M850.12 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    className: "cls-1",
    d: "M850.12 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    className: "cls-1",
    d: "M850.12 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    className: "cls-1",
    d: "M850.12 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    className: "cls-1",
    d: "M850.12 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    className: "cls-1",
    d: "M850.12 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    className: "cls-1",
    d: "M850.12 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    className: "cls-1",
    d: "M850.12 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    className: "cls-1",
    d: "M850.12 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    className: "cls-1",
    d: "M850.12 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    className: "cls-1",
    d: "M850.12 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    className: "cls-1",
    d: "M850.12 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    className: "cls-1",
    d: "M850.12 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    className: "cls-1",
    d: "M850.12 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    className: "cls-1",
    d: "M850.12 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    className: "cls-1",
    d: "M850.12 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    className: "cls-1",
    d: "M850.12 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    className: "cls-1",
    d: "M850.12 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    className: "cls-1",
    d: "M850.12 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    className: "cls-1",
    d: "M850.12 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    className: "cls-1",
    d: "M850.12 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    className: "cls-1",
    d: "M850.12 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    className: "cls-1",
    d: "M850.12 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    className: "cls-1",
    d: "M850.12 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    className: "cls-1",
    d: "M850.12 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    className: "cls-1",
    d: "M850.12 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    className: "cls-1",
    d: "M850.12 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    className: "cls-1",
    d: "M850.12 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    className: "cls-1",
    d: "M850.12 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    className: "cls-1",
    d: "M850.12 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    className: "cls-1",
    d: "M850.12 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    className: "cls-1",
    d: "M850.12 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    className: "cls-1",
    d: "M850.12 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    className: "cls-1",
    d: "M850.12 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    className: "cls-1",
    d: "M850.12 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    className: "cls-1",
    d: "M837.34 74.63a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    className: "cls-1",
    d: "M837.34 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    className: "cls-1",
    d: "M837.34 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    className: "cls-1",
    d: "M837.34 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    className: "cls-1",
    d: "M837.34 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    className: "cls-1",
    d: "M837.34 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    className: "cls-1",
    d: "M837.34 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    className: "cls-1",
    d: "M837.34 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    className: "cls-1",
    d: "M837.34 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    className: "cls-1",
    d: "M837.34 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    className: "cls-1",
    d: "M837.34 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    className: "cls-1",
    d: "M837.34 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    className: "cls-1",
    d: "M837.34 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    className: "cls-1",
    d: "M837.34 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    className: "cls-1",
    d: "M837.34 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    className: "cls-1",
    d: "M837.34 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    className: "cls-1",
    d: "M837.34 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    className: "cls-1",
    d: "M837.34 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    className: "cls-1",
    d: "M837.34 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    className: "cls-1",
    d: "M837.34 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    className: "cls-1",
    d: "M837.34 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    className: "cls-1",
    d: "M837.34 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    className: "cls-1",
    d: "M837.34 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    className: "cls-1",
    d: "M837.34 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    className: "cls-1",
    d: "M837.34 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    className: "cls-1",
    d: "M837.34 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    className: "cls-1",
    d: "M837.34 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    className: "cls-1",
    d: "M837.34 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    className: "cls-1",
    d: "M837.34 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    className: "cls-1",
    d: "M837.34 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    className: "cls-1",
    d: "M837.34 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    className: "cls-1",
    d: "M837.34 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    className: "cls-1",
    d: "M837.34 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    className: "cls-1",
    d: "M837.34 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    className: "cls-1",
    d: "M837.34 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-1",
    d: "M837.34 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    className: "cls-1",
    d: "M837.34 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    className: "cls-1",
    d: "M837.34 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    className: "cls-1",
    d: "M837.34 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    className: "cls-1",
    d: "M837.34 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    className: "cls-1",
    d: "M837.34 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    className: "cls-1",
    d: "M824.58 74.63A3.6 3.6 0 11821 71a3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    className: "cls-1",
    d: "M824.58 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    className: "cls-1",
    d: "M824.58 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    className: "cls-1",
    d: "M824.58 176.76a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    className: "cls-1",
    d: "M824.58 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    className: "cls-1",
    d: "M824.58 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    className: "cls-1",
    d: "M824.58 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    className: "cls-1",
    d: "M824.58 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    className: "cls-1",
    d: "M824.58 240.59A3.6 3.6 0 11821 237a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    className: "cls-1",
    d: "M824.58 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    className: "cls-1",
    d: "M824.58 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    className: "cls-1",
    d: "M824.58 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    className: "cls-1",
    d: "M824.58 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    className: "cls-1",
    d: "M824.58 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    className: "cls-1",
    d: "M824.58 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    className: "cls-1",
    d: "M824.58 330a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    className: "cls-1",
    d: "M824.58 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    className: "cls-1",
    d: "M824.58 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    className: "cls-1",
    d: "M824.58 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    className: "cls-1",
    d: "M824.58 393.78a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    className: "cls-1",
    d: "M824.58 406.55A3.6 3.6 0 11821 403a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    className: "cls-1",
    d: "M824.58 419.31a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    className: "cls-1",
    d: "M824.58 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    className: "cls-1",
    d: "M824.58 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    className: "cls-1",
    d: "M824.58 457.61A3.6 3.6 0 11821 454a3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    className: "cls-1",
    d: "M824.58 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    className: "cls-1",
    d: "M824.58 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    className: "cls-1",
    d: "M824.58 495.91a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    className: "cls-1",
    d: "M824.58 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    className: "cls-1",
    d: "M824.58 521.45a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    className: "cls-1",
    d: "M824.58 534.21a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    className: "cls-1",
    d: "M824.58 547a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    className: "cls-1",
    d: "M824.58 559.74a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    className: "cls-1",
    d: "M824.58 572.51a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    className: "cls-1",
    d: "M824.58 585.28a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    className: "cls-1",
    d: "M824.58 598a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    className: "cls-1",
    d: "M824.58 610.8a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    className: "cls-1",
    d: "M824.58 623.58A3.6 3.6 0 11821 620a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    className: "cls-1",
    d: "M824.58 636.34a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    className: "cls-1",
    d: "M824.58 649.11a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    className: "cls-1",
    d: "M824.58 661.87a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    className: "cls-1",
    d: "M824.58 674.64A3.6 3.6 0 11821 671a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    className: "cls-1",
    d: "M811.8 74.63a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    className: "cls-1",
    d: "M811.8 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    className: "cls-1",
    d: "M811.8 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    className: "cls-1",
    d: "M811.8 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    className: "cls-1",
    d: "M811.8 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    className: "cls-1",
    d: "M811.8 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    className: "cls-1",
    d: "M811.8 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    className: "cls-1",
    d: "M811.8 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    className: "cls-1",
    d: "M811.8 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    className: "cls-1",
    d: "M811.8 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    className: "cls-1",
    d: "M811.8 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    className: "cls-1",
    d: "M811.8 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    className: "cls-1",
    d: "M811.8 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    className: "cls-1",
    d: "M811.8 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    className: "cls-1",
    d: "M811.8 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    className: "cls-1",
    d: "M811.8 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    className: "cls-1",
    d: "M811.8 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    className: "cls-1",
    d: "M811.8 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    className: "cls-1",
    d: "M811.8 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    className: "cls-1",
    d: "M811.8 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    className: "cls-1",
    d: "M811.8 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    className: "cls-1",
    d: "M811.8 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    className: "cls-1",
    d: "M811.8 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    className: "cls-1",
    d: "M811.8 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    className: "cls-1",
    d: "M811.8 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    className: "cls-1",
    d: "M811.8 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    className: "cls-1",
    d: "M811.8 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    className: "cls-1",
    d: "M811.8 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    className: "cls-1",
    d: "M811.8 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    className: "cls-1",
    d: "M811.8 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    className: "cls-1",
    d: "M811.8 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    className: "cls-1",
    d: "M811.8 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    className: "cls-1",
    d: "M811.8 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    className: "cls-1",
    d: "M811.8 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    className: "cls-1",
    d: "M811.8 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    className: "cls-1",
    d: "M811.8 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    className: "cls-1",
    d: "M811.8 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    className: "cls-1",
    d: "M811.8 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    className: "cls-1",
    d: "M811.8 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    className: "cls-1",
    d: "M811.8 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    className: "cls-1",
    d: "M799 74.63a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    className: "cls-1",
    d: "M799 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    className: "cls-1",
    d: "M799 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    className: "cls-1",
    d: "M799 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    className: "cls-1",
    d: "M799 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    className: "cls-1",
    d: "M799 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    className: "cls-1",
    d: "M799 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    className: "cls-1",
    d: "M799 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    className: "cls-1",
    d: "M799 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    className: "cls-1",
    d: "M799 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    className: "cls-1",
    d: "M799 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    className: "cls-1",
    d: "M799 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    className: "cls-1",
    d: "M799 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    className: "cls-1",
    d: "M799 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    className: "cls-1",
    d: "M799 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    className: "cls-1",
    d: "M799 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    className: "cls-1",
    d: "M799 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    className: "cls-1",
    d: "M799 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    className: "cls-1",
    d: "M799 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    className: "cls-1",
    d: "M799 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    className: "cls-1",
    d: "M799 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    className: "cls-1",
    d: "M799 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    className: "cls-1",
    d: "M799 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    className: "cls-1",
    d: "M799 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    className: "cls-1",
    d: "M799 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    className: "cls-1",
    d: "M799 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    className: "cls-1",
    d: "M799 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    className: "cls-1",
    d: "M799 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    className: "cls-1",
    d: "M799 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    className: "cls-1",
    d: "M799 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    className: "cls-1",
    d: "M799 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    className: "cls-1",
    d: "M799 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    className: "cls-1",
    d: "M799 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    className: "cls-1",
    d: "M799 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    className: "cls-1",
    d: "M799 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    className: "cls-1",
    d: "M799 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    className: "cls-1",
    d: "M799 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    className: "cls-1",
    d: "M786.26 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    className: "cls-1",
    d: "M786.26 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    className: "cls-1",
    d: "M786.26 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    className: "cls-1",
    d: "M786.26 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    className: "cls-1",
    d: "M786.26 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    className: "cls-1",
    d: "M786.26 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    className: "cls-1",
    d: "M786.26 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    className: "cls-1",
    d: "M786.26 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    className: "cls-1",
    d: "M786.26 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    className: "cls-1",
    d: "M786.26 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    className: "cls-1",
    d: "M786.26 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    className: "cls-1",
    d: "M786.26 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    className: "cls-1",
    d: "M786.26 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    className: "cls-1",
    d: "M786.26 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    className: "cls-1",
    d: "M786.26 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    className: "cls-1",
    d: "M786.26 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    className: "cls-1",
    d: "M786.26 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    className: "cls-1",
    d: "M786.26 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    className: "cls-1",
    d: "M786.26 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    className: "cls-1",
    d: "M786.26 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    className: "cls-1",
    d: "M786.26 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    className: "cls-1",
    d: "M786.26 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    className: "cls-1",
    d: "M786.26 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    className: "cls-1",
    d: "M786.26 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    className: "cls-1",
    d: "M786.26 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    className: "cls-1",
    d: "M786.26 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    className: "cls-1",
    d: "M786.26 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    className: "cls-1",
    d: "M786.26 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    className: "cls-1",
    d: "M786.26 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    className: "cls-1",
    d: "M786.26 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    className: "cls-1",
    d: "M786.26 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    className: "cls-1",
    d: "M786.26 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    className: "cls-1",
    d: "M786.26 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    className: "cls-1",
    d: "M786.26 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    className: "cls-1",
    d: "M786.26 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    className: "cls-1",
    d: "M786.26 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    className: "cls-1",
    d: "M773.49 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    className: "cls-1",
    d: "M773.49 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    className: "cls-1",
    d: "M773.49 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    className: "cls-1",
    d: "M773.49 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    className: "cls-1",
    d: "M773.49 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    className: "cls-1",
    d: "M773.49 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    className: "cls-1",
    d: "M773.49 266.12a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    className: "cls-1",
    d: "M773.49 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    className: "cls-1",
    d: "M773.49 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    className: "cls-1",
    d: "M773.49 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    className: "cls-1",
    d: "M773.49 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    className: "cls-1",
    d: "M773.49 330a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    className: "cls-1",
    d: "M773.49 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    className: "cls-1",
    d: "M773.49 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    className: "cls-1",
    d: "M773.49 393.78a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    className: "cls-1",
    d: "M773.49 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    className: "cls-1",
    d: "M773.49 419.31a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    className: "cls-1",
    d: "M773.49 432.08a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    className: "cls-1",
    d: "M773.49 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    className: "cls-1",
    d: "M773.49 457.61a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    className: "cls-1",
    d: "M773.49 470.38a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    className: "cls-1",
    d: "M773.49 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    className: "cls-1",
    d: "M773.49 495.91a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    className: "cls-1",
    d: "M773.49 508.68a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    className: "cls-1",
    d: "M773.49 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    className: "cls-1",
    d: "M773.49 534.21a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    className: "cls-1",
    d: "M773.49 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    className: "cls-1",
    d: "M773.49 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    className: "cls-1",
    d: "M773.49 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    className: "cls-1",
    d: "M760.71 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    className: "cls-1",
    d: "M760.71 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    className: "cls-1",
    d: "M760.71 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    className: "cls-1",
    d: "M760.71 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    className: "cls-1",
    d: "M760.71 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    className: "cls-1",
    d: "M760.71 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    className: "cls-1",
    d: "M760.71 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    className: "cls-1",
    d: "M760.71 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    className: "cls-1",
    d: "M760.71 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    className: "cls-1",
    d: "M760.71 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    className: "cls-1",
    d: "M760.71 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    className: "cls-1",
    d: "M760.71 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    className: "cls-1",
    d: "M760.71 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    className: "cls-1",
    d: "M760.71 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    className: "cls-1",
    d: "M760.71 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    className: "cls-1",
    d: "M760.71 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    className: "cls-1",
    d: "M760.71 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    className: "cls-1",
    d: "M760.71 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    className: "cls-1",
    d: "M760.71 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    className: "cls-1",
    d: "M760.71 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    className: "cls-1",
    d: "M760.71 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    className: "cls-1",
    d: "M760.71 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    className: "cls-1",
    d: "M760.71 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    className: "cls-1",
    d: "M760.71 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    className: "cls-1",
    d: "M760.71 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    className: "cls-1",
    d: "M760.71 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    className: "cls-1",
    d: "M748 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    className: "cls-1",
    d: "M748 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    className: "cls-1",
    d: "M748 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    className: "cls-1",
    d: "M748 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    className: "cls-1",
    d: "M748 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    className: "cls-1",
    d: "M748 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    className: "cls-1",
    d: "M748 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    className: "cls-1",
    d: "M748 330a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    className: "cls-1",
    d: "M748 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    className: "cls-1",
    d: "M748 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    className: "cls-1",
    d: "M748 393.78a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    className: "cls-1",
    d: "M748 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    className: "cls-1",
    d: "M748 419.31a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    className: "cls-1",
    d: "M748 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    className: "cls-1",
    d: "M748 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    className: "cls-1",
    d: "M748 457.61a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    className: "cls-1",
    d: "M748 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    className: "cls-1",
    d: "M748 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    className: "cls-1",
    d: "M748 495.91a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    className: "cls-1",
    d: "M735.17 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    className: "cls-1",
    d: "M735.17 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    className: "cls-1",
    d: "M735.17 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    className: "cls-1",
    d: "M735.17 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    className: "cls-1",
    d: "M735.17 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    className: "cls-1",
    d: "M735.17 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    className: "cls-1",
    d: "M735.17 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    className: "cls-1",
    d: "M735.17 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    className: "cls-1",
    d: "M735.17 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    className: "cls-1",
    d: "M735.17 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    className: "cls-1",
    d: "M735.17 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    className: "cls-1",
    d: "M735.17 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    className: "cls-1",
    d: "M735.17 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    className: "cls-1",
    d: "M735.17 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    className: "cls-1",
    d: "M735.17 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    className: "cls-1",
    d: "M722.4 291.65a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    className: "cls-1",
    d: "M722.4 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    className: "cls-1",
    d: "M722.4 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    className: "cls-1",
    d: "M722.4 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    className: "cls-1",
    d: "M722.4 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    className: "cls-1",
    d: "M722.4 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    className: "cls-1",
    d: "M722.4 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    className: "cls-1",
    d: "M722.4 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    className: "cls-1",
    d: "M722.4 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    className: "cls-1",
    d: "M722.4 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    className: "cls-1",
    d: "M722.4 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    className: "cls-1",
    d: "M722.4 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    className: "cls-1",
    d: "M722.4 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    className: "cls-1",
    d: "M722.4 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    className: "cls-1",
    d: "M722.4 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    className: "cls-1",
    d: "M722.4 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    className: "cls-1",
    d: "M709.63 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    className: "cls-1",
    d: "M709.63 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    className: "cls-1",
    d: "M709.63 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    className: "cls-1",
    d: "M709.63 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    className: "cls-1",
    d: "M709.63 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    className: "cls-1",
    d: "M709.63 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    className: "cls-1",
    d: "M709.63 406.55A3.6 3.6 0 11706 403a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    className: "cls-1",
    d: "M709.63 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    className: "cls-1",
    d: "M709.63 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    className: "cls-1",
    d: "M709.63 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    className: "cls-1",
    d: "M709.63 457.61A3.6 3.6 0 11706 454a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    className: "cls-1",
    d: "M709.63 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    className: "cls-1",
    d: "M709.63 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    className: "cls-1",
    d: "M709.63 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    className: "cls-1",
    d: "M696.86 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    className: "cls-1",
    d: "M696.86 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    className: "cls-1",
    d: "M696.86 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    className: "cls-1",
    d: "M696.86 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    className: "cls-1",
    d: "M696.86 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    className: "cls-1",
    d: "M696.86 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    className: "cls-1",
    d: "M696.86 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    className: "cls-1",
    d: "M696.86 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    className: "cls-1",
    d: "M696.86 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    className: "cls-1",
    d: "M696.86 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    className: "cls-1",
    d: "M696.86 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    className: "cls-1",
    d: "M696.86 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    className: "cls-1",
    d: "M696.86 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    className: "cls-1",
    d: "M696.86 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    className: "cls-1",
    d: "M696.86 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    className: "cls-1",
    d: "M684.09 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    className: "cls-1",
    d: "M684.09 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    className: "cls-1",
    d: "M684.09 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    className: "cls-1",
    d: "M684.09 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    className: "cls-1",
    d: "M684.09 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    className: "cls-1",
    d: "M684.09 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    className: "cls-1",
    d: "M684.09 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    className: "cls-1",
    d: "M684.09 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    className: "cls-1",
    d: "M684.09 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    className: "cls-1",
    d: "M684.09 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    className: "cls-1",
    d: "M684.09 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    className: "cls-1",
    d: "M684.09 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    className: "cls-1",
    d: "M684.09 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    className: "cls-1",
    d: "M684.09 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    className: "cls-1",
    d: "M684.09 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    className: "cls-1",
    d: "M671.32 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    className: "cls-1",
    d: "M671.32 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    className: "cls-1",
    d: "M671.32 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    className: "cls-1",
    d: "M671.32 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    className: "cls-1",
    d: "M671.32 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    className: "cls-1",
    d: "M671.32 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    className: "cls-1",
    d: "M671.32 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    className: "cls-1",
    d: "M671.32 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    className: "cls-1",
    d: "M671.32 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    className: "cls-1",
    d: "M658.54 419.31a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    className: "cls-1",
    d: "M658.54 432.08a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    className: "cls-1",
    d: "M658.54 444.85a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    className: "cls-1",
    d: "M658.54 457.61A3.6 3.6 0 11655 454a3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    className: "cls-1",
    d: "M658.54 470.38a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    className: "cls-1",
    d: "M658.54 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    className: "cls-1",
    d: "M658.54 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    className: "cls-1",
    d: "M645.77 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    className: "cls-1",
    d: "M645.77 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    className: "cls-1",
    d: "M645.77 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    className: "cls-1",
    d: "M645.77 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    className: "cls-1",
    d: "M645.77 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    className: "cls-1",
    d: "M645.77 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    className: "cls-1",
    d: "M645.77 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    className: "cls-1",
    d: "M645.77 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    className: "cls-1",
    d: "M633 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    className: "cls-1",
    d: "M633 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    className: "cls-1",
    d: "M633 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    className: "cls-1",
    d: "M633 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    className: "cls-1",
    d: "M633 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    className: "cls-1",
    d: "M633 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    className: "cls-1",
    d: "M633 93a3.6 3.6 0 11-3.6-3.6A3.6 3.6 0 01633 93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    className: "cls-1",
    d: "M633 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    className: "cls-1",
    d: "M633 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    className: "cls-1",
    d: "M633 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    className: "cls-1",
    d: "M620.23 3.6a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    className: "cls-1",
    d: "M620.23 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    className: "cls-1",
    d: "M620.23 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    className: "cls-1",
    d: "M620.23 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    className: "cls-1",
    d: "M620.23 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    className: "cls-1",
    d: "M620.23 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    className: "cls-1",
    d: "M620.23 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    className: "cls-1",
    d: "M620.23 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    className: "cls-1",
    d: "M620.23 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    className: "cls-1",
    d: "M620.23 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    className: "cls-1",
    d: "M620.23 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    className: "cls-1",
    d: "M607.46 3.6a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    className: "cls-1",
    d: "M607.46 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    className: "cls-1",
    d: "M607.46 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    className: "cls-1",
    d: "M607.46 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    className: "cls-1",
    d: "M607.46 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    className: "cls-1",
    d: "M607.46 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    className: "cls-1",
    d: "M607.46 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    className: "cls-1",
    d: "M607.46 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    className: "cls-1",
    d: "M607.46 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    className: "cls-1",
    d: "M607.46 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    className: "cls-1",
    d: "M607.46 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    className: "cls-1",
    d: "M607.46 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    className: "cls-1",
    d: "M594.68 3.6a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    className: "cls-1",
    d: "M594.68 16.37a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    className: "cls-1",
    d: "M594.68 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.59 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    className: "cls-1",
    d: "M594.68 41.9a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    className: "cls-1",
    d: "M594.68 54.67a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    className: "cls-1",
    d: "M594.68 67.43a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    className: "cls-1",
    d: "M594.68 80.2a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    className: "cls-1",
    d: "M594.68 93a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    className: "cls-1",
    d: "M594.68 105.73a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    className: "cls-1",
    d: "M594.68 118.49a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    className: "cls-1",
    d: "M594.68 131.26a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    className: "cls-1",
    d: "M594.68 144a3.6 3.6 0 11-3.59-3.6 3.6 3.6 0 013.59 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    className: "cls-1",
    d: "M581.92 3.6a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    className: "cls-1",
    d: "M581.92 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    className: "cls-1",
    d: "M581.92 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    className: "cls-1",
    d: "M581.92 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    className: "cls-1",
    d: "M581.92 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    className: "cls-1",
    d: "M581.92 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    className: "cls-1",
    d: "M581.92 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    className: "cls-1",
    d: "M581.92 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    className: "cls-1",
    d: "M581.92 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    className: "cls-1",
    d: "M581.92 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    className: "cls-1",
    d: "M581.92 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    className: "cls-1",
    d: "M581.92 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    className: "cls-1",
    d: "M581.92 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    className: "cls-1",
    d: "M569.15 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    className: "cls-1",
    d: "M569.15 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    className: "cls-1",
    d: "M569.14 3.6a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    className: "cls-1",
    d: "M569.14 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    className: "cls-1",
    d: "M569.14 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    className: "cls-1",
    d: "M569.14 41.9a3.6 3.6 0 11-3.6-3.6 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    className: "cls-1",
    d: "M569.14 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    className: "cls-1",
    d: "M569.14 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    className: "cls-1",
    d: "M569.14 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    className: "cls-1",
    d: "M569.14 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    className: "cls-1",
    d: "M569.14 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    className: "cls-1",
    d: "M569.14 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    className: "cls-1",
    d: "M569.14 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    className: "cls-1",
    d: "M569.14 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    className: "cls-1",
    d: "M569.14 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    className: "cls-1",
    d: "M556.37 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    className: "cls-1",
    d: "M556.37 559.74a3.6 3.6 0 11-3.6-3.6 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    className: "cls-1",
    d: "M556.37 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    className: "cls-1",
    d: "M556.37 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    className: "cls-1",
    d: "M556.37 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    className: "cls-1",
    d: "M556.37 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    className: "cls-1",
    d: "M556.37 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    className: "cls-1",
    d: "M556.37 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    className: "cls-1",
    d: "M556.37 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    className: "cls-1",
    d: "M556.37 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    className: "cls-1",
    d: "M556.37 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    className: "cls-1",
    d: "M556.37 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    className: "cls-1",
    d: "M556.37 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    className: "cls-1",
    d: "M556.37 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    className: "cls-1",
    d: "M556.37 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    className: "cls-1",
    d: "M556.37 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    className: "cls-1",
    d: "M556.37 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    className: "cls-1",
    d: "M556.37 169.56a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    className: "cls-1",
    d: "M556.37 182.33a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    className: "cls-1",
    d: "M543.6 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    className: "cls-1",
    d: "M543.6 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    className: "cls-1",
    d: "M543.6 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    className: "cls-1",
    d: "M543.6 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    className: "cls-1",
    d: "M543.6 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    className: "cls-1",
    d: "M543.6 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    className: "cls-1",
    d: "M543.6 623.58A3.6 3.6 0 11540 620a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    className: "cls-1",
    d: "M543.6 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    className: "cls-1",
    d: "M543.6 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    className: "cls-1",
    d: "M543.6 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    className: "cls-1",
    d: "M543.6 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    className: "cls-1",
    d: "M543.6 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    className: "cls-1",
    d: "M543.6 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    className: "cls-1",
    d: "M543.6 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    className: "cls-1",
    d: "M543.6 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    className: "cls-1",
    d: "M543.6 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    className: "cls-1",
    d: "M543.6 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    className: "cls-1",
    d: "M543.6 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    className: "cls-1",
    d: "M543.6 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    className: "cls-1",
    d: "M543.6 169.56A3.6 3.6 0 11540 166a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    className: "cls-1",
    d: "M543.6 182.33a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    className: "cls-1",
    d: "M543.6 195.09a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    className: "cls-1",
    d: "M530.83 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    className: "cls-1",
    d: "M530.83 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    className: "cls-1",
    d: "M530.83 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    className: "cls-1",
    d: "M530.83 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    className: "cls-1",
    d: "M530.83 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    className: "cls-1",
    d: "M530.83 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    className: "cls-1",
    d: "M530.83 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    className: "cls-1",
    d: "M530.83 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    className: "cls-1",
    d: "M530.83 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    className: "cls-1",
    d: "M530.83 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    className: "cls-1",
    d: "M530.83 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    className: "cls-1",
    d: "M530.83 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    className: "cls-1",
    d: "M530.83 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    className: "cls-1",
    d: "M530.83 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    className: "cls-1",
    d: "M530.83 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    className: "cls-1",
    d: "M530.83 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    className: "cls-1",
    d: "M530.83 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    className: "cls-1",
    d: "M530.83 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    className: "cls-1",
    d: "M530.83 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    className: "cls-1",
    d: "M530.83 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    className: "cls-1",
    d: "M530.83 169.56a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    className: "cls-1",
    d: "M530.83 182.33a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    className: "cls-1",
    d: "M530.83 195.09a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    className: "cls-1",
    d: "M518.06 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    className: "cls-1",
    d: "M518.06 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    className: "cls-1",
    d: "M518.06 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    className: "cls-1",
    d: "M518.06 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    className: "cls-1",
    d: "M518.06 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    className: "cls-1",
    d: "M518.06 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    className: "cls-1",
    d: "M518.06 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    className: "cls-1",
    d: "M518.06 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    className: "cls-1",
    d: "M518.06 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    className: "cls-1",
    d: "M518.06 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    className: "cls-1",
    d: "M518.06 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    className: "cls-1",
    d: "M518.06 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    className: "cls-1",
    d: "M518.06 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    className: "cls-1",
    d: "M518.06 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    className: "cls-1",
    d: "M518.06 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    className: "cls-1",
    d: "M518.06 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    className: "cls-1",
    d: "M518.06 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    className: "cls-1",
    d: "M518.06 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    className: "cls-1",
    d: "M518.06 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    className: "cls-1",
    d: "M518.06 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    className: "cls-1",
    d: "M518.06 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    className: "cls-1",
    d: "M518.06 169.56a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    className: "cls-1",
    d: "M518.06 182.33a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    className: "cls-1",
    d: "M505.29 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    className: "cls-1",
    d: "M505.29 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    className: "cls-1",
    d: "M505.29 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    className: "cls-1",
    d: "M505.29 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    className: "cls-1",
    d: "M505.29 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    className: "cls-1",
    d: "M505.29 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    className: "cls-1",
    d: "M505.29 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    className: "cls-1",
    d: "M505.29 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    className: "cls-1",
    d: "M505.29 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    className: "cls-1",
    d: "M505.29 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    className: "cls-1",
    d: "M505.29 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    className: "cls-1",
    d: "M505.29 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    className: "cls-1",
    d: "M505.29 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    className: "cls-1",
    d: "M505.29 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    className: "cls-1",
    d: "M505.29 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    className: "cls-1",
    d: "M505.29 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    className: "cls-1",
    d: "M505.29 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    className: "cls-1",
    d: "M505.29 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    className: "cls-1",
    d: "M505.29 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    className: "cls-1",
    d: "M505.29 105.73a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    className: "cls-1",
    d: "M505.29 118.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    className: "cls-1",
    d: "M505.29 131.26a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    className: "cls-1",
    d: "M505.29 144a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    className: "cls-1",
    d: "M505.29 156.79a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    className: "cls-1",
    d: "M492.52 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    className: "cls-1",
    d: "M492.52 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    className: "cls-1",
    d: "M492.52 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    className: "cls-1",
    d: "M492.52 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    className: "cls-1",
    d: "M492.52 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    className: "cls-1",
    d: "M492.52 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    className: "cls-1",
    d: "M492.52 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    className: "cls-1",
    d: "M492.52 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    className: "cls-1",
    d: "M492.52 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    className: "cls-1",
    d: "M492.52 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    className: "cls-1",
    d: "M492.52 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    className: "cls-1",
    d: "M492.52 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    className: "cls-1",
    d: "M492.52 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    className: "cls-1",
    d: "M492.52 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    className: "cls-1",
    d: "M492.52 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    className: "cls-1",
    d: "M492.52 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    className: "cls-1",
    d: "M492.52 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    className: "cls-1",
    d: "M492.52 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    className: "cls-1",
    d: "M492.52 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    className: "cls-1",
    d: "M492.52 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    className: "cls-1",
    d: "M492.52 93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    className: "cls-1",
    d: "M479.75 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    className: "cls-1",
    d: "M479.75 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    className: "cls-1",
    d: "M479.75 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    className: "cls-1",
    d: "M479.75 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    className: "cls-1",
    d: "M479.75 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    className: "cls-1",
    d: "M479.75 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    className: "cls-1",
    d: "M479.75 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    className: "cls-1",
    d: "M479.75 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    className: "cls-1",
    d: "M479.75 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    className: "cls-1",
    d: "M479.75 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    className: "cls-1",
    d: "M479.75 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    className: "cls-1",
    d: "M479.75 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    className: "cls-1",
    d: "M479.75 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    className: "cls-1",
    d: "M479.75 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    className: "cls-1",
    d: "M479.75 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    className: "cls-1",
    d: "M479.75 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    className: "cls-1",
    d: "M479.75 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-1",
    d: "M479.75 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    className: "cls-1",
    d: "M479.74 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    className: "cls-1",
    d: "M479.74 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    className: "cls-1",
    d: "M479.74 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    className: "cls-1",
    d: "M479.74 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    className: "cls-1",
    d: "M479.74 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    className: "cls-1",
    d: "M467 266.12a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    className: "cls-1",
    d: "M467 278.89a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    className: "cls-1",
    d: "M467 304.42a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    className: "cls-1",
    d: "M467 495.91a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    className: "cls-1",
    d: "M467 508.68a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    className: "cls-1",
    d: "M467 521.45a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    className: "cls-1",
    d: "M467 534.21a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    className: "cls-1",
    d: "M467 547a3.61 3.61 0 11-3.61-3.6A3.6 3.6 0 01467 547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    className: "cls-1",
    d: "M467 559.74a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    className: "cls-1",
    d: "M467 572.51a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    className: "cls-1",
    d: "M467 585.28a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    className: "cls-1",
    d: "M467 598a3.61 3.61 0 11-3.61-3.6A3.6 3.6 0 01467 598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    className: "cls-1",
    d: "M467 610.8a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    className: "cls-1",
    d: "M467 623.58a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    className: "cls-1",
    d: "M467 636.34a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    className: "cls-1",
    d: "M467 649.11a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    className: "cls-1",
    d: "M467 661.87a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    className: "cls-1",
    d: "M467 674.64a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    className: "cls-1",
    d: "M467 687.4a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    className: "cls-1",
    d: "M467 700.17a3.61 3.61 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    className: "cls-1",
    d: "M467 16.37a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    className: "cls-1",
    d: "M467 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    className: "cls-1",
    d: "M467 41.9a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    className: "cls-1",
    d: "M467 54.67a3.61 3.61 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    className: "cls-1",
    d: "M467 67.43a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    className: "cls-1",
    d: "M467 80.2a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    className: "cls-1",
    d: "M454.2 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    className: "cls-1",
    d: "M454.2 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    className: "cls-1",
    d: "M454.2 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    className: "cls-1",
    d: "M454.2 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    className: "cls-1",
    d: "M454.2 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    className: "cls-1",
    d: "M454.2 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    className: "cls-1",
    d: "M454.2 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    className: "cls-1",
    d: "M454.2 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    className: "cls-1",
    d: "M454.2 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    className: "cls-1",
    d: "M454.2 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    className: "cls-1",
    d: "M454.2 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    className: "cls-1",
    d: "M454.2 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    className: "cls-1",
    d: "M454.2 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    className: "cls-1",
    d: "M454.2 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    className: "cls-1",
    d: "M454.2 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    className: "cls-1",
    d: "M454.2 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    className: "cls-1",
    d: "M454.2 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    className: "cls-1",
    d: "M454.2 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    className: "cls-1",
    d: "M454.2 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    className: "cls-1",
    d: "M454.2 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    className: "cls-1",
    d: "M454.2 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    className: "cls-1",
    d: "M454.2 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    className: "cls-1",
    d: "M454.2 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    className: "cls-1",
    d: "M454.2 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    className: "cls-1",
    d: "M454.2 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    className: "cls-1",
    d: "M454.2 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    className: "cls-1",
    d: "M454.2 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    className: "cls-1",
    d: "M454.2 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    className: "cls-1",
    d: "M454.2 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    className: "cls-1",
    d: "M454.2 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    className: "cls-1",
    d: "M441.43 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    className: "cls-1",
    d: "M441.43 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    className: "cls-1",
    d: "M441.43 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    className: "cls-1",
    d: "M441.43 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    className: "cls-1",
    d: "M441.43 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    className: "cls-1",
    d: "M441.43 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    className: "cls-1",
    d: "M441.43 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    className: "cls-1",
    d: "M441.43 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    className: "cls-1",
    d: "M441.43 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    className: "cls-1",
    d: "M441.43 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    className: "cls-1",
    d: "M441.43 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    className: "cls-1",
    d: "M441.43 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    className: "cls-1",
    d: "M441.43 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    className: "cls-1",
    d: "M441.43 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    className: "cls-1",
    d: "M441.43 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    className: "cls-1",
    d: "M441.43 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    className: "cls-1",
    d: "M441.43 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    className: "cls-1",
    d: "M441.43 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    className: "cls-1",
    d: "M441.43 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    className: "cls-1",
    d: "M441.43 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    className: "cls-1",
    d: "M441.43 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    className: "cls-1",
    d: "M441.43 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    className: "cls-1",
    d: "M441.43 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    className: "cls-1",
    d: "M441.43 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    className: "cls-1",
    d: "M441.43 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    className: "cls-1",
    d: "M441.43 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    className: "cls-1",
    d: "M441.43 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    className: "cls-1",
    d: "M441.43 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    className: "cls-1",
    d: "M441.43 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    className: "cls-1",
    d: "M441.43 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    className: "cls-1",
    d: "M441.43 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    className: "cls-1",
    d: "M441.43 789.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    className: "cls-1",
    d: "M441.43 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    className: "cls-1",
    d: "M441.43 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    className: "cls-1",
    d: "M441.43 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    className: "cls-1",
    d: "M441.43 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    className: "cls-1",
    d: "M441.43 80.2a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    className: "cls-1",
    d: "M428.66 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    className: "cls-1",
    d: "M428.66 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    className: "cls-1",
    d: "M428.66 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    className: "cls-1",
    d: "M428.66 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    className: "cls-1",
    d: "M428.66 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    className: "cls-1",
    d: "M428.66 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    className: "cls-1",
    d: "M428.66 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    className: "cls-1",
    d: "M428.66 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    className: "cls-1",
    d: "M428.66 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    className: "cls-1",
    d: "M428.66 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    className: "cls-1",
    d: "M428.66 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    className: "cls-1",
    d: "M428.66 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    className: "cls-1",
    d: "M428.66 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    className: "cls-1",
    d: "M428.66 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    className: "cls-1",
    d: "M428.66 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    className: "cls-1",
    d: "M428.66 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    className: "cls-1",
    d: "M428.66 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    className: "cls-1",
    d: "M428.66 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    className: "cls-1",
    d: "M428.66 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    className: "cls-1",
    d: "M428.66 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    className: "cls-1",
    d: "M428.66 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    className: "cls-1",
    d: "M428.66 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    className: "cls-1",
    d: "M428.66 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    className: "cls-1",
    d: "M428.66 610.8a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    className: "cls-1",
    d: "M428.66 623.58a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    className: "cls-1",
    d: "M428.66 636.34a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    className: "cls-1",
    d: "M428.66 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    className: "cls-1",
    d: "M428.66 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    className: "cls-1",
    d: "M428.66 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    className: "cls-1",
    d: "M428.66 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    className: "cls-1",
    d: "M428.66 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    className: "cls-1",
    d: "M428.66 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    className: "cls-1",
    d: "M428.66 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    className: "cls-1",
    d: "M428.66 738.47a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    className: "cls-1",
    d: "M428.66 751.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    className: "cls-1",
    d: "M428.66 776.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    className: "cls-1",
    d: "M428.66 789.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    className: "cls-1",
    d: "M428.66 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    className: "cls-1",
    d: "M428.66 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    className: "cls-1",
    d: "M428.66 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    className: "cls-1",
    d: "M428.66 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    className: "cls-1",
    d: "M428.66 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    className: "cls-1",
    d: "M415.89 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    className: "cls-1",
    d: "M415.89 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    className: "cls-1",
    d: "M415.89 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    className: "cls-1",
    d: "M415.89 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    className: "cls-1",
    d: "M415.89 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    className: "cls-1",
    d: "M415.89 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    className: "cls-1",
    d: "M415.89 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    className: "cls-1",
    d: "M415.89 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    className: "cls-1",
    d: "M415.89 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    className: "cls-1",
    d: "M415.89 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    className: "cls-1",
    d: "M415.89 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    className: "cls-1",
    d: "M415.89 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    className: "cls-1",
    d: "M415.89 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    className: "cls-1",
    d: "M415.89 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    className: "cls-1",
    d: "M415.89 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    className: "cls-1",
    d: "M415.89 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    className: "cls-1",
    d: "M415.89 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    className: "cls-1",
    d: "M415.89 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    className: "cls-1",
    d: "M415.89 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    className: "cls-1",
    d: "M415.89 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    className: "cls-1",
    d: "M415.89 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    className: "cls-1",
    d: "M415.89 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    className: "cls-1",
    d: "M415.89 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    className: "cls-1",
    d: "M415.89 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    className: "cls-1",
    d: "M415.89 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    className: "cls-1",
    d: "M415.89 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    className: "cls-1",
    d: "M415.89 598a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    className: "cls-1",
    d: "M415.89 649.11a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    className: "cls-1",
    d: "M415.89 661.87a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    className: "cls-1",
    d: "M415.89 674.64a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    className: "cls-1",
    d: "M415.89 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    className: "cls-1",
    d: "M415.89 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    className: "cls-1",
    d: "M415.89 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    className: "cls-1",
    d: "M415.89 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    className: "cls-1",
    d: "M415.89 738.47a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    className: "cls-1",
    d: "M415.89 751.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    className: "cls-1",
    d: "M415.89 764a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    className: "cls-1",
    d: "M415.89 776.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    className: "cls-1",
    d: "M415.89 789.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    className: "cls-1",
    d: "M415.89 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    className: "cls-1",
    d: "M415.89 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    className: "cls-1",
    d: "M415.89 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    className: "cls-1",
    d: "M403.12 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    className: "cls-1",
    d: "M403.12 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    className: "cls-1",
    d: "M403.12 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    className: "cls-1",
    d: "M403.12 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    className: "cls-1",
    d: "M403.12 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    className: "cls-1",
    d: "M403.12 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    className: "cls-1",
    d: "M403.12 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    className: "cls-1",
    d: "M403.12 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    className: "cls-1",
    d: "M403.12 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    className: "cls-1",
    d: "M403.12 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    className: "cls-1",
    d: "M403.12 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    className: "cls-1",
    d: "M403.12 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    className: "cls-1",
    d: "M403.12 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    className: "cls-1",
    d: "M403.12 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    className: "cls-1",
    d: "M403.12 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    className: "cls-1",
    d: "M403.12 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    className: "cls-1",
    d: "M403.12 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    className: "cls-1",
    d: "M403.12 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    className: "cls-1",
    d: "M403.12 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    className: "cls-1",
    d: "M403.12 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    className: "cls-1",
    d: "M403.12 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    className: "cls-1",
    d: "M403.12 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    className: "cls-1",
    d: "M403.12 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    className: "cls-1",
    d: "M403.12 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    className: "cls-1",
    d: "M403.12 585.28a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    className: "cls-1",
    d: "M403.12 712.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    className: "cls-1",
    d: "M403.12 725.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    className: "cls-1",
    d: "M403.12 738.47a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    className: "cls-1",
    d: "M403.12 751.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    className: "cls-1",
    d: "M403.12 764a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    className: "cls-1",
    d: "M403.12 776.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    className: "cls-1",
    d: "M403.11 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    className: "cls-1",
    d: "M403.11 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    className: "cls-1",
    d: "M403.11 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    className: "cls-1",
    d: "M403.11 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    className: "cls-1",
    d: "M390.34 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    className: "cls-1",
    d: "M390.34 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    className: "cls-1",
    d: "M390.34 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    className: "cls-1",
    d: "M390.34 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    className: "cls-1",
    d: "M390.34 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    className: "cls-1",
    d: "M390.34 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    className: "cls-1",
    d: "M390.34 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    className: "cls-1",
    d: "M390.34 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    className: "cls-1",
    d: "M390.34 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    className: "cls-1",
    d: "M390.34 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    className: "cls-1",
    d: "M390.34 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    className: "cls-1",
    d: "M390.34 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    className: "cls-1",
    d: "M390.34 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    className: "cls-1",
    d: "M390.34 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    className: "cls-1",
    d: "M390.34 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    className: "cls-1",
    d: "M390.34 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    className: "cls-1",
    d: "M390.34 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    className: "cls-1",
    d: "M390.34 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    className: "cls-1",
    d: "M390.34 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    className: "cls-1",
    d: "M390.34 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    className: "cls-1",
    d: "M390.34 508.68a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    className: "cls-1",
    d: "M390.34 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    className: "cls-1",
    d: "M390.34 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    className: "cls-1",
    d: "M390.34 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    className: "cls-1",
    d: "M390.34 559.74a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    className: "cls-1",
    d: "M390.34 572.51a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    className: "cls-1",
    d: "M390.35 16.37a3.61 3.61 0 11-3.61-3.6 3.61 3.61 0 013.61 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    className: "cls-1",
    d: "M390.35 29.13a3.6 3.6 0 11-3.61-3.59 3.6 3.6 0 013.61 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    className: "cls-1",
    d: "M390.35 41.9a3.61 3.61 0 11-3.61-3.6 3.61 3.61 0 013.61 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    className: "cls-1",
    d: "M390.35 54.67a3.61 3.61 0 11-3.61-3.6 3.61 3.61 0 013.61 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    className: "cls-1",
    d: "M390.35 67.43a3.61 3.61 0 11-3.61-3.6 3.61 3.61 0 013.61 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    className: "cls-1",
    d: "M377.57 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    className: "cls-1",
    d: "M377.57 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    className: "cls-1",
    d: "M377.57 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    className: "cls-1",
    d: "M377.57 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    className: "cls-1",
    d: "M377.57 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    className: "cls-1",
    d: "M377.57 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    className: "cls-1",
    d: "M377.57 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    className: "cls-1",
    d: "M377.57 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    className: "cls-1",
    d: "M377.57 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    className: "cls-1",
    d: "M377.57 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    className: "cls-1",
    d: "M377.57 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    className: "cls-1",
    d: "M377.57 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    className: "cls-1",
    d: "M377.57 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    className: "cls-1",
    d: "M377.57 406.55A3.6 3.6 0 11374 403a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    className: "cls-1",
    d: "M377.57 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    className: "cls-1",
    d: "M377.57 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    className: "cls-1",
    d: "M377.57 495.91a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    className: "cls-1",
    d: "M377.57 521.45a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    className: "cls-1",
    d: "M377.57 534.21a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    className: "cls-1",
    d: "M377.57 547a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    className: "cls-1",
    d: "M377.57 16.37a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    className: "cls-1",
    d: "M377.57 29.13a3.6 3.6 0 11-3.6-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    className: "cls-1",
    d: "M377.57 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    className: "cls-1",
    d: "M377.57 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    className: "cls-1",
    d: "M377.57 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    className: "cls-1",
    d: "M364.8 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    className: "cls-1",
    d: "M364.8 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    className: "cls-1",
    d: "M364.8 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    className: "cls-1",
    d: "M364.8 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    className: "cls-1",
    d: "M364.8 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    className: "cls-1",
    d: "M364.8 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    className: "cls-1",
    d: "M364.8 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    className: "cls-1",
    d: "M364.8 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    className: "cls-1",
    d: "M364.8 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    className: "cls-1",
    d: "M364.8 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    className: "cls-1",
    d: "M364.8 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    className: "cls-1",
    d: "M364.8 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    className: "cls-1",
    d: "M364.8 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    className: "cls-1",
    d: "M364.8 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    className: "cls-1",
    d: "M364.8 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    className: "cls-1",
    d: "M364.8 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    className: "cls-1",
    d: "M364.8 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    className: "cls-1",
    d: "M364.8 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    className: "cls-1",
    d: "M364.8 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    className: "cls-1",
    d: "M364.8 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    className: "cls-1",
    d: "M364.8 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    className: "cls-1",
    d: "M364.8 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    className: "cls-1",
    d: "M364.8 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    className: "cls-1",
    d: "M364.8 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    className: "cls-1",
    d: "M364.8 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    className: "cls-1",
    d: "M364.8 67.43a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    className: "cls-1",
    d: "M352 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    className: "cls-1",
    d: "M352 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    className: "cls-1",
    d: "M352 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    className: "cls-1",
    d: "M352 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    className: "cls-1",
    d: "M352 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    className: "cls-1",
    d: "M352 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    className: "cls-1",
    d: "M352 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    className: "cls-1",
    d: "M352 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    className: "cls-1",
    d: "M352 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    className: "cls-1",
    d: "M352 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    className: "cls-1",
    d: "M352 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    className: "cls-1",
    d: "M352 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    className: "cls-1",
    d: "M352 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    className: "cls-1",
    d: "M352 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    className: "cls-1",
    d: "M352 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    className: "cls-1",
    d: "M352 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    className: "cls-1",
    d: "M352 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    className: "cls-1",
    d: "M352 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    className: "cls-1",
    d: "M352 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    className: "cls-1",
    d: "M352 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    className: "cls-1",
    d: "M352 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    className: "cls-1",
    d: "M352 483.15a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    className: "cls-1",
    d: "M352 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    className: "cls-1",
    d: "M352 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    className: "cls-1",
    d: "M352 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    className: "cls-1",
    d: "M339.26 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    className: "cls-1",
    d: "M339.26 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    className: "cls-1",
    d: "M339.26 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    className: "cls-1",
    d: "M339.26 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    className: "cls-1",
    d: "M339.26 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    className: "cls-1",
    d: "M339.26 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    className: "cls-1",
    d: "M339.26 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    className: "cls-1",
    d: "M339.26 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    className: "cls-1",
    d: "M339.26 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    className: "cls-1",
    d: "M339.26 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    className: "cls-1",
    d: "M339.26 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    className: "cls-1",
    d: "M339.26 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    className: "cls-1",
    d: "M339.26 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    className: "cls-1",
    d: "M339.26 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    className: "cls-1",
    d: "M339.26 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    className: "cls-1",
    d: "M339.26 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    className: "cls-1",
    d: "M339.26 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    className: "cls-1",
    d: "M339.26 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    className: "cls-1",
    d: "M339.26 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    className: "cls-1",
    d: "M339.26 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    className: "cls-1",
    d: "M339.26 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    className: "cls-1",
    d: "M339.26 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    className: "cls-1",
    d: "M339.26 470.38a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    className: "cls-1",
    d: "M339.26 29.13a3.6 3.6 0 11-3.61-3.59 3.59 3.59 0 013.6 3.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    className: "cls-1",
    d: "M339.26 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    className: "cls-1",
    d: "M339.26 54.67a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    className: "cls-1",
    d: "M326.49 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    className: "cls-1",
    d: "M326.49 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    className: "cls-1",
    d: "M326.49 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    className: "cls-1",
    d: "M326.49 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    className: "cls-1",
    d: "M326.49 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    className: "cls-1",
    d: "M326.49 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    className: "cls-1",
    d: "M326.49 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    className: "cls-1",
    d: "M326.49 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    className: "cls-1",
    d: "M326.49 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    className: "cls-1",
    d: "M326.49 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    className: "cls-1",
    d: "M326.49 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    className: "cls-1",
    d: "M326.49 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    className: "cls-1",
    d: "M326.49 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    className: "cls-1",
    d: "M326.49 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    className: "cls-1",
    d: "M326.49 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    className: "cls-1",
    d: "M326.49 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    className: "cls-1",
    d: "M326.49 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    className: "cls-1",
    d: "M326.49 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    className: "cls-1",
    d: "M326.49 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    className: "cls-1",
    d: "M326.49 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    className: "cls-1",
    d: "M326.49 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    className: "cls-1",
    d: "M326.49 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    className: "cls-1",
    d: "M326.49 41.9a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    className: "cls-1",
    d: "M313.72 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    className: "cls-1",
    d: "M313.72 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    className: "cls-1",
    d: "M313.72 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    className: "cls-1",
    d: "M313.72 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    className: "cls-1",
    d: "M313.72 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    className: "cls-1",
    d: "M313.72 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    className: "cls-1",
    d: "M313.72 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    className: "cls-1",
    d: "M313.72 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    className: "cls-1",
    d: "M313.72 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    className: "cls-1",
    d: "M313.72 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    className: "cls-1",
    d: "M313.72 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    className: "cls-1",
    d: "M313.72 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    className: "cls-1",
    d: "M313.72 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    className: "cls-1",
    d: "M313.72 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    className: "cls-1",
    d: "M313.72 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    className: "cls-1",
    d: "M313.72 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    className: "cls-1",
    d: "M313.72 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    className: "cls-1",
    d: "M313.72 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    className: "cls-1",
    d: "M313.72 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    className: "cls-1",
    d: "M313.72 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    className: "cls-1",
    d: "M313.72 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    className: "cls-1",
    d: "M313.72 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    className: "cls-1",
    d: "M313.72 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    className: "cls-1",
    d: "M313.72 457.61a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    className: "cls-1",
    d: "M301 87.4a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    className: "cls-1",
    d: "M301 112.93a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    className: "cls-1",
    d: "M301 138.46a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    className: "cls-1",
    d: "M301 151.23a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    className: "cls-1",
    d: "M301 164a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    className: "cls-1",
    d: "M301 176.76a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    className: "cls-1",
    d: "M301 189.53a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    className: "cls-1",
    d: "M301 202.29a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    className: "cls-1",
    d: "M301 215.06a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    className: "cls-1",
    d: "M301 227.82a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    className: "cls-1",
    d: "M301 240.59a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    className: "cls-1",
    d: "M301 253.36a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    className: "cls-1",
    d: "M301 266.12a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    className: "cls-1",
    d: "M301 278.89a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    className: "cls-1",
    d: "M301 291.65a3.61 3.61 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    className: "cls-1",
    d: "M301 304.42a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    className: "cls-1",
    d: "M301 317.19a3.61 3.61 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    className: "cls-1",
    d: "M301 330a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    className: "cls-1",
    d: "M301 342.72a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    className: "cls-1",
    d: "M301 355.49a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    className: "cls-1",
    d: "M301 368.25a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    className: "cls-1",
    d: "M301 381a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    className: "cls-1",
    d: "M301 393.78a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    className: "cls-1",
    d: "M301 406.55a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    className: "cls-1",
    d: "M301 419.31a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    className: "cls-1",
    d: "M301 432.08a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    className: "cls-1",
    d: "M301 444.85a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    className: "cls-1",
    d: "M301 457.61a3.61 3.61 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    className: "cls-1",
    d: "M288.18 74.63a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    className: "cls-1",
    d: "M288.18 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    className: "cls-1",
    d: "M288.18 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    className: "cls-1",
    d: "M288.18 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    className: "cls-1",
    d: "M288.18 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    className: "cls-1",
    d: "M288.18 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    className: "cls-1",
    d: "M288.18 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    className: "cls-1",
    d: "M288.18 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    className: "cls-1",
    d: "M288.18 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    className: "cls-1",
    d: "M288.18 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    className: "cls-1",
    d: "M288.18 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    className: "cls-1",
    d: "M288.18 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    className: "cls-1",
    d: "M288.18 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    className: "cls-1",
    d: "M288.18 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    className: "cls-1",
    d: "M288.18 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    className: "cls-1",
    d: "M288.18 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    className: "cls-1",
    d: "M288.18 317.19a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    className: "cls-1",
    d: "M288.18 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    className: "cls-1",
    d: "M288.18 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    className: "cls-1",
    d: "M288.18 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    className: "cls-1",
    d: "M288.18 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    className: "cls-1",
    d: "M288.18 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    className: "cls-1",
    d: "M288.18 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    className: "cls-1",
    d: "M288.18 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    className: "cls-1",
    d: "M288.18 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    className: "cls-1",
    d: "M288.18 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    className: "cls-1",
    d: "M288.18 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    className: "cls-1",
    d: "M275.4 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    className: "cls-1",
    d: "M275.4 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    className: "cls-1",
    d: "M275.4 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    className: "cls-1",
    d: "M275.4 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    className: "cls-1",
    d: "M275.4 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    className: "cls-1",
    d: "M275.4 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    className: "cls-1",
    d: "M275.4 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    className: "cls-1",
    d: "M275.4 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    className: "cls-1",
    d: "M275.4 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    className: "cls-1",
    d: "M275.4 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    className: "cls-1",
    d: "M275.4 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    className: "cls-1",
    d: "M275.4 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    className: "cls-1",
    d: "M275.4 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    className: "cls-1",
    d: "M275.4 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    className: "cls-1",
    d: "M275.4 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    className: "cls-1",
    d: "M275.4 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    className: "cls-1",
    d: "M275.4 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    className: "cls-1",
    d: "M275.4 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    className: "cls-1",
    d: "M275.4 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    className: "cls-1",
    d: "M275.4 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    className: "cls-1",
    d: "M275.4 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    className: "cls-1",
    d: "M275.4 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    className: "cls-1",
    d: "M275.4 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    className: "cls-1",
    d: "M275.4 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    className: "cls-1",
    d: "M275.4 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    className: "cls-1",
    d: "M275.4 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    className: "cls-1",
    d: "M275.4 432.08a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    className: "cls-1",
    d: "M275.4 444.85a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    className: "cls-1",
    d: "M262.63 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    className: "cls-1",
    d: "M262.63 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    className: "cls-1",
    d: "M262.63 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    className: "cls-1",
    d: "M262.63 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    className: "cls-1",
    d: "M262.63 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    className: "cls-1",
    d: "M262.63 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    className: "cls-1",
    d: "M262.63 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    className: "cls-1",
    d: "M262.63 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    className: "cls-1",
    d: "M262.63 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    className: "cls-1",
    d: "M262.63 240.59A3.6 3.6 0 11259 237a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    className: "cls-1",
    d: "M262.63 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    className: "cls-1",
    d: "M262.63 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    className: "cls-1",
    d: "M262.63 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    className: "cls-1",
    d: "M262.63 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    className: "cls-1",
    d: "M262.63 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    className: "cls-1",
    d: "M262.63 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    className: "cls-1",
    d: "M262.63 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    className: "cls-1",
    d: "M262.63 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    className: "cls-1",
    d: "M262.63 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    className: "cls-1",
    d: "M262.63 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    className: "cls-1",
    d: "M262.63 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    className: "cls-1",
    d: "M262.63 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    className: "cls-1",
    d: "M262.63 406.55A3.6 3.6 0 11259 403a3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    className: "cls-1",
    d: "M262.63 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    className: "cls-1",
    d: "M249.86 87.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    className: "cls-1",
    d: "M249.86 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    className: "cls-1",
    d: "M249.86 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    className: "cls-1",
    d: "M249.86 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    className: "cls-1",
    d: "M249.86 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    className: "cls-1",
    d: "M249.86 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    className: "cls-1",
    d: "M249.86 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    className: "cls-1",
    d: "M249.86 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    className: "cls-1",
    d: "M249.86 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    className: "cls-1",
    d: "M249.86 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    className: "cls-1",
    d: "M249.86 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    className: "cls-1",
    d: "M249.86 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    className: "cls-1",
    d: "M249.86 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    className: "cls-1",
    d: "M249.86 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    className: "cls-1",
    d: "M249.86 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    className: "cls-1",
    d: "M249.86 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    className: "cls-1",
    d: "M249.86 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    className: "cls-1",
    d: "M249.86 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    className: "cls-1",
    d: "M249.86 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    className: "cls-1",
    d: "M249.86 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    className: "cls-1",
    d: "M249.86 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    className: "cls-1",
    d: "M249.86 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    className: "cls-1",
    d: "M249.86 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    className: "cls-1",
    d: "M249.86 419.31a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    className: "cls-1",
    d: "M237.09 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    className: "cls-1",
    d: "M237.09 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    className: "cls-1",
    d: "M237.09 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    className: "cls-1",
    d: "M237.09 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    className: "cls-1",
    d: "M237.09 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    className: "cls-1",
    d: "M237.09 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    className: "cls-1",
    d: "M237.09 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    className: "cls-1",
    d: "M237.09 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    className: "cls-1",
    d: "M237.09 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    className: "cls-1",
    d: "M237.09 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    className: "cls-1",
    d: "M237.09 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    className: "cls-1",
    d: "M237.09 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    className: "cls-1",
    d: "M237.09 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    className: "cls-1",
    d: "M237.09 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    className: "cls-1",
    d: "M237.09 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    className: "cls-1",
    d: "M237.09 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    className: "cls-1",
    d: "M237.09 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    className: "cls-1",
    d: "M237.09 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    className: "cls-1",
    d: "M237.09 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    className: "cls-1",
    d: "M237.09 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    className: "cls-1",
    d: "M237.09 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    className: "cls-1",
    d: "M237.09 393.78a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    className: "cls-1",
    d: "M237.09 406.55a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    className: "cls-1",
    d: "M224.32 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    className: "cls-1",
    d: "M224.32 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    className: "cls-1",
    d: "M224.32 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    className: "cls-1",
    d: "M224.32 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    className: "cls-1",
    d: "M224.32 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    className: "cls-1",
    d: "M224.32 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    className: "cls-1",
    d: "M224.32 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    className: "cls-1",
    d: "M224.32 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    className: "cls-1",
    d: "M224.32 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    className: "cls-1",
    d: "M224.32 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    className: "cls-1",
    d: "M224.32 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    className: "cls-1",
    d: "M224.32 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    className: "cls-1",
    d: "M224.32 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    className: "cls-1",
    d: "M224.32 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    className: "cls-1",
    d: "M224.32 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    className: "cls-1",
    d: "M224.32 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    className: "cls-1",
    d: "M224.32 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    className: "cls-1",
    d: "M224.32 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    className: "cls-1",
    d: "M224.32 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    className: "cls-1",
    d: "M224.32 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    className: "cls-1",
    d: "M224.32 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    className: "cls-1",
    d: "M224.32 381a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    className: "cls-1",
    d: "M211.54 100.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    className: "cls-1",
    d: "M211.54 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    className: "cls-1",
    d: "M211.54 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    className: "cls-1",
    d: "M211.54 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    className: "cls-1",
    d: "M211.54 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    className: "cls-1",
    d: "M211.54 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    className: "cls-1",
    d: "M211.54 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    className: "cls-1",
    d: "M211.54 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    className: "cls-1",
    d: "M211.54 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    className: "cls-1",
    d: "M211.54 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    className: "cls-1",
    d: "M211.54 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    className: "cls-1",
    d: "M211.54 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    className: "cls-1",
    d: "M211.54 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    className: "cls-1",
    d: "M211.54 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    className: "cls-1",
    d: "M211.54 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    className: "cls-1",
    d: "M211.54 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    className: "cls-1",
    d: "M211.54 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    className: "cls-1",
    d: "M211.54 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    className: "cls-1",
    d: "M211.54 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    className: "cls-1",
    d: "M211.54 368.25a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    className: "cls-1",
    d: "M198.77 112.93a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    className: "cls-1",
    d: "M198.77 125.7a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    className: "cls-1",
    d: "M198.77 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    className: "cls-1",
    d: "M198.77 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    className: "cls-1",
    d: "M198.77 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    className: "cls-1",
    d: "M198.77 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    className: "cls-1",
    d: "M198.77 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    className: "cls-1",
    d: "M198.77 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    className: "cls-1",
    d: "M198.77 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    className: "cls-1",
    d: "M198.77 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    className: "cls-1",
    d: "M198.77 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    className: "cls-1",
    d: "M198.77 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    className: "cls-1",
    d: "M198.77 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    className: "cls-1",
    d: "M198.77 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    className: "cls-1",
    d: "M198.77 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    className: "cls-1",
    d: "M198.77 304.42a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    className: "cls-1",
    d: "M198.77 317.19a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    className: "cls-1",
    d: "M198.77 330a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    className: "cls-1",
    d: "M198.77 342.72a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    className: "cls-1",
    d: "M198.77 355.49a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    className: "cls-1",
    d: "M186 138.46a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    className: "cls-1",
    d: "M186 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    className: "cls-1",
    d: "M186 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    className: "cls-1",
    d: "M186 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    className: "cls-1",
    d: "M186 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    className: "cls-1",
    d: "M186 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    className: "cls-1",
    d: "M186 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    className: "cls-1",
    d: "M186 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    className: "cls-1",
    d: "M186 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    className: "cls-1",
    d: "M186 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    className: "cls-1",
    d: "M186 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    className: "cls-1",
    d: "M186 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    className: "cls-1",
    d: "M186 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    className: "cls-1",
    d: "M173.23 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    className: "cls-1",
    d: "M173.23 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    className: "cls-1",
    d: "M173.23 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    className: "cls-1",
    d: "M173.23 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    className: "cls-1",
    d: "M173.23 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    className: "cls-1",
    d: "M173.23 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    className: "cls-1",
    d: "M173.23 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    className: "cls-1",
    d: "M173.23 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    className: "cls-1",
    d: "M173.23 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    className: "cls-1",
    d: "M173.23 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    className: "cls-1",
    d: "M173.23 291.65a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    className: "cls-1",
    d: "M160.46 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    className: "cls-1",
    d: "M160.46 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    className: "cls-1",
    d: "M160.46 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    className: "cls-1",
    d: "M160.46 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    className: "cls-1",
    d: "M160.46 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    className: "cls-1",
    d: "M160.46 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    className: "cls-1",
    d: "M160.46 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    className: "cls-1",
    d: "M160.46 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    className: "cls-1",
    d: "M160.46 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    className: "cls-1",
    d: "M147.69 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    className: "cls-1",
    d: "M147.69 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    className: "cls-1",
    d: "M147.69 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    className: "cls-1",
    d: "M147.69 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    className: "cls-1",
    d: "M147.69 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    className: "cls-1",
    d: "M147.69 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    className: "cls-1",
    d: "M147.69 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    className: "cls-1",
    d: "M147.69 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    className: "cls-1",
    d: "M134.91 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    className: "cls-1",
    d: "M134.91 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    className: "cls-1",
    d: "M134.91 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    className: "cls-1",
    d: "M134.91 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    className: "cls-1",
    d: "M134.91 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    className: "cls-1",
    d: "M134.91 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    className: "cls-1",
    d: "M122.15 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    className: "cls-1",
    d: "M122.15 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    className: "cls-1",
    d: "M122.15 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    className: "cls-1",
    d: "M122.15 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    className: "cls-1",
    d: "M122.15 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    className: "cls-1",
    d: "M122.15 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    className: "cls-1",
    d: "M109.38 164a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    className: "cls-1",
    d: "M109.38 176.76a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    className: "cls-1",
    d: "M109.38 189.53a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    className: "cls-1",
    d: "M109.38 202.29a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    className: "cls-1",
    d: "M109.38 215.06a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    className: "cls-1",
    d: "M109.38 227.82a3.6 3.6 0 11-3.6-3.6 3.61 3.61 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    className: "cls-1",
    d: "M96.6 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    className: "cls-1",
    d: "M96.6 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    className: "cls-1",
    d: "M96.6 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    className: "cls-1",
    d: "M96.6 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    className: "cls-1",
    d: "M96.6 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    className: "cls-1",
    d: "M96.6 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    className: "cls-1",
    d: "M83.83 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    className: "cls-1",
    d: "M83.83 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    className: "cls-1",
    d: "M83.83 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    className: "cls-1",
    d: "M83.83 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    className: "cls-1",
    d: "M83.83 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    className: "cls-1",
    d: "M83.83 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    className: "cls-1",
    d: "M71.06 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    className: "cls-1",
    d: "M71.06 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    className: "cls-1",
    d: "M71.06 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    className: "cls-1",
    d: "M71.06 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    className: "cls-1",
    d: "M71.06 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    className: "cls-1",
    d: "M71.06 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    className: "cls-1",
    d: "M71.06 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    className: "cls-1",
    d: "M58.29 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    className: "cls-1",
    d: "M58.29 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    className: "cls-1",
    d: "M58.29 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    className: "cls-1",
    d: "M58.29 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    className: "cls-1",
    d: "M58.29 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    className: "cls-1",
    d: "M58.29 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    className: "cls-1",
    d: "M58.29 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    className: "cls-1",
    d: "M58.29 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    className: "cls-1",
    d: "M58.29 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    className: "cls-1",
    d: "M45.52 151.23a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    className: "cls-1",
    d: "M45.52 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    className: "cls-1",
    d: "M45.52 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    className: "cls-1",
    d: "M45.52 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    className: "cls-1",
    d: "M45.52 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    className: "cls-1",
    d: "M45.52 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    className: "cls-1",
    d: "M45.52 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    className: "cls-1",
    d: "M45.52 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    className: "cls-1",
    d: "M45.52 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    className: "cls-1",
    d: "M32.74 164a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    className: "cls-1",
    d: "M32.74 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    className: "cls-1",
    d: "M32.74 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    className: "cls-1",
    d: "M32.74 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    className: "cls-1",
    d: "M32.74 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    className: "cls-1",
    d: "M32.74 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    className: "cls-1",
    d: "M32.74 240.59a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    className: "cls-1",
    d: "M32.74 253.36a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    className: "cls-1",
    d: "M32.74 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    className: "cls-1",
    d: "M20 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    className: "cls-1",
    d: "M20 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    className: "cls-1",
    d: "M20 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    className: "cls-1",
    d: "M20 215.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    className: "cls-1",
    d: "M20 227.82a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    className: "cls-1",
    d: "M20 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    className: "cls-1",
    d: "M7.2 176.76a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    className: "cls-1",
    d: "M7.2 189.53a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    className: "cls-1",
    d: "M7.2 202.29a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    className: "cls-1",
    d: "M7.2 266.12a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    className: "cls-1",
    d: "M7.2 278.89a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    className: "cls-1",
    d: "M441.43 803.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    className: "cls-1",
    d: "M824.58 687.4a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    className: "cls-1",
    d: "M811.8 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    className: "cls-1",
    d: "M799 687.4a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    className: "cls-1",
    d: "M811.8 700.17a3.6 3.6 0 11-3.61-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    className: "cls-1",
    d: "M799 700.17a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    className: "cls-1",
    d: "M799 714.06a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5993bb3424cbf76577af82a54468bc8b.svg";
export { ForwardRef as ReactComponent };